<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;" v-loading.fullscreen.lock="confirmLoading">
    <div style="padding:20px;width:100%;">
      <div style="width:400px;float: left;">
        <div class="whiteBox">
          <h4 style="font-size:20px;height:unset;">
            {{ customer.name }}
            <span style="font-weight:400;font-size:18px;">{{
              customer.mobile
            }}</span>
            <el-button size="medium" type="text" style="float:right;margin-top:-7px;" class="filter-item"
              v-if="onlyView == false" @click="showEditDialog">编辑</el-button>
            <!-- xPhone：虚拟号，接口与 customer 同级返回，有值才显示；附刷新图标仅重取智慧号 -->
            <div v-if="xPhone" style="margin-top: 10px;font-size:14px;">智慧号：{{ xPhone }}
              <i class="fa fa-refresh fa-fw" style="cursor: pointer;" aria-hidden="true" title="刷新智慧号"
                @click="refreshXPhone"></i>
            </div>
          </h4>
          <div style="margin-top:15px;">
            <el-tag style="margin-right:3px;margin-bottom:3px;" size="small" type="warning"
              v-if="customer.onlineSourceName != ''">{{ customer.onlineSourceName }}</el-tag>
            <el-tag style="margin-right:3px;margin-bottom:3px;" size="small" type="warning">{{ customer.gender == 1 ? "男"
              : "女" }}</el-tag>
            <el-tag style="margin-right:3px;margin-bottom:3px;" size="small" type="warning">{{ customer.type == 1 ? "个人" :
              "企业" }}</el-tag>
            <!-- <el-tag style="margin-right:3px;margin-bottom:3px;" size="small" v-if="fromSourceDisplay(customer.FromSource)"
              type="warning">{{ `渠道：${fromSourceDisplay(customer.FromSource)}` }}</el-tag> -->
            <el-tag style="margin-right:3px;margin-bottom:3px;" size="small" type="warning"
              v-for="(item, index) in systemTags" :key="index">{{ item }}</el-tag>
          </div>
          <div style="margin-top:10px;">
            <el-tag size="small" type="info" style="margin-right:3px;margin-bottom:3px;"
              v-for="item in customer.tag.split(' ')" v-show="customer.tag != ''" :key="item">{{ item }}</el-tag>
            <el-tag size="small" style="background-color:white;cursor: pointer;" v-if="onlyView == false"
              @click.native="showTagDialog">画像编辑</el-tag>
          </div>
          <!-- CDP标签 -->
          <CDPTag :cdpTag="cdpTag"></CDPTag>
          <!-- 企微标签 -->
          <QwTag :tags="qiWeiTag"></QwTag>
          <div class="pure-g" style="margin-top:10px;">
            <div class="pure-u-1-3 el-form-item__label">
              <p>客户经理</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ deal.ownerName }}</p>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">
              <p>渠道</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ info.sourceName }}</p>
              <!-- <p>{{ fromSourceDisplay(customer.FromSource) }}</p> -->
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">
              <p>创建时间</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ deal.createdAt | parseTime("{y}年{m}月{d}日 {h}:{i}") }}</p>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">
              <p>客户级别</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ info.level | levelDisplay }}</p>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">
              <p>意向车系</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ intendSeriese }}</p>
            </div>
          </div>
          <div class="pure-g" v-show="competitionSerie != ''">
            <div class="pure-u-1-3 el-form-item__label">
              <p>意向竞品</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ competitionSerie }}</p>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">
              <p>性别</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ customer.gender == 1 ? "先生" : "女士" }}</p>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">
              <p>首触渠道</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ info.sourceName }}</p>
            </div>
          </div>
          <div class="pure-g" v-if="newMediaUrl && newMediaUrl.length > 0">
            <div class="pure-u-1-3 el-form-item__label">
              <p>客户来源凭证</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <Upload ref="upload" v-model="newMediaUrl" disabled isMini >
              </Upload>
            </div>
          </div>
          
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">
              <p>再激活渠道</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ info.reactivateSource }}</p>
            </div>
          </div>
          <div class="pure-g" v-if="customer.companyName != ''&&customer.type==2 ">
            <div class="pure-u-1-3 el-form-item__label">
              <p>公司名称</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ customer.companyName }}</p>
            </div>
          </div>
          <div class="pure-g" v-if="customer.secondaryPhone != ''">
            <div class="pure-u-1-3 el-form-item__label">
              <p>其他联系号码</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ customer.secondaryPhone }}</p>
            </div>
          </div>
          <div class="pure-g" v-show="deal.budget != 0">
            <div class="pure-u-1-3 el-form-item__label">
              <p>购车预算</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ deal.budget | budgetDisplay }}</p>
            </div>
          </div>
          <div class="pure-g" v-show="customer.buycarDate != 0">
            <div class="pure-u-1-3 el-form-item__label">
              <p>预计购车时间</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>
                {{ customer.buycarDate | parseTime("{y}年{m}月{d}日") }}之前
              </p>
            </div>
          </div>

          <div class="pure-g" v-if="deal.orderDate > 0 && (deal.level == 'O' || deal.level == 'D')
            ">
            <div class="pure-u-1-3 el-form-item__label">
              <p>订车时间</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ deal.orderDate | parseTime("{y}年{m}月{d}日") }}</p>
            </div>
          </div>
          <div class="pure-g" v-if="deal.deliverDate > 0 && deal.level == 'D'">
            <div class="pure-u-1-3 el-form-item__label">
              <p>交车时间</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ deal.deliverDate | parseTime("{y}年{m}月{d}日") }}</p>
            </div>
          </div>
          <div class="pure-g" v-if="deal.failDate > 0 && deal.level == 'F'">
            <div class="pure-u-1-3 el-form-item__label">
              <p>战败时间</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ deal.failDate | parseTime("{y}年{m}月{d}日") }}</p>
            </div>
          </div>
          <div class="pure-g" v-if="deal.failDate > 0 && deal.level == 'F'">
            <div class="pure-u-1-3 el-form-item__label">
              <p>交叉回访</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ info.crossRecall ? "是" : "否" }}</p>
            </div>
          </div>
          <div style="margin-top:10px;" class="line-separator"></div>
          <div v-if="onlyView == false && deal.waitingFailReview == false">
            <el-button v-if="!isSuspend &&
              (deal.level == 'N' ||
                deal.level == 'H' ||
                deal.level == 'A' ||
                deal.level == 'B' ||
                deal.level == 'C' ||
                deal.level == 'O')
              " style="margin-right:5px;margin-top:5px;" size="small" @click="toOrder">订车</el-button>
            <!-- <el-button v-if="!deal.isSuspend && deal.level == 'O'"
                       style="margin-right:5px;margin-top:5px;"
                       size="small"
                       @click="showDeliverDialog">交车</el-button> -->
            <el-button v-if="deal.level == 'F'" style="margin-right:5px;margin-top:5px;" size="small"
              @click="showReliveDialog">复活</el-button>
            <el-button v-if="deal.level == 'D'" style="margin-right:5px;margin-top:5px;" size="small"
              @click="toHandleVisit(info.isSuspend)">{{ info.isSuspend ? '继续回访' : '暂停回访' }}</el-button>
            <el-button v-if="isSuspend && deal.level != 'F'" style="margin-right:5px;margin-top:5px;" size="small"
              @click="doResume">{{ deal.level == "D" ? "继续跟进" : "唤醒" }}</el-button>
            <el-button style="margin-right:5px;margin-top:5px;" size="small" @click="showRemarkDialog">批注</el-button>
            <el-button v-if="(allowAssign && deal.level != 'F') || loginInfo.canResign"
              style="margin-right:5px;margin-top:5px;" size="small" @click="showAssignDialog">再分配</el-button>
              <!-- 客户级别-交车 -->
            <el-button v-if="customer.createdNew == false && deal.level == 'D'" style="margin-right:5px;margin-top:5px;"
              size="small" @click="showNewCustomerDialog">再次购车</el-button>
            <el-button v-if="orderList.length === 0 && deal.level == 'O'" style="margin-right:5px;margin-top:5px;"
              size="small" @click="showFailDialog">战败</el-button>
          </div>
          <div v-if="deal.waitingFailReview && deal.level == 'F' && !allowFailVerify
            ">
            <el-button v-if="deal.level == 'F'" style="margin-right:5px;margin-top:5px;" size="small"
              @click="showReliveDialog">复活</el-button>
          </div>
          <div v-if="deal.waitingFailReview && deal.level == 'F' && allowFailVerify
            ">
            <el-button v-if="deal.level == 'F'" style="margin-right:5px;margin-top:5px;" size="small"
              @click="showReliveDialog">复活</el-button>
            <el-button style="margin-right:5px;margin-top:5px;" size="small" @click="confirmFail">同意战败</el-button>
            <el-button style="margin-right:5px;margin-top:5px;" size="small"
              @click="showRejectFailDialog">驳回战败</el-button>
          </div>
          <el-button v-if="isFromFront" style="margin-right:5px;margin-top:5px;" size="small"
            @click="informCome">确认到店</el-button>
        </div>

        <div class="whiteBox" style="margin-top:20px;" v-if="pendingActivity != null">
          <h4 style="font-size:16px;">
            下次跟进
            <el-button size="medium" type="text" style="float:right;margin-top:-7px;" class="filter-item"
              v-if="onlyView == false" @click="showFollowDialog">跟进</el-button>
            <!-- <el-button size="medium"
                       type="text"
                       style="float:right;margin-top:-7px;"
                       class="filter-item"
                       v-if="onlyView == false && orderList[0] && orderList[0].status === 4"
                       @click="showReturnDialog">回访</el-button> -->
          </h4>
          <div class="pure-g" style="margin-top:10px;">
            <div class="pure-u-1-3 el-form-item__label">
              <p>客户经理</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ pendingActivity.ownerName }}</p>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">
              <p>计划时间</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>
                {{
                  pendingActivity.activityDate | parseTime("{y}年{m}月{d}日")
                }}
              </p>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">
              <p>跟进方式</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ pendingActivity.type | activityTypeDisplay }}</p>
            </div>
          </div>
          <div class="pure-g" v-if="pendingActivity.type == 3 && pendingActivity.testSpecName != ''
            ">
            <div class="pure-u-1-3 el-form-item__label">
              <p>试驾车型</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ pendingActivity.testSpecName }}</p>
            </div>
          </div>
        </div>
        <div class="whiteBox" style="margin-top:20px;" v-if="orderList.length > 0">
          <h4 style="font-size:16px;">
            {{ orderTitleMap.get(orderList[0].zzType) }}
            <el-button size="medium" type="text" style="float:right;margin-top:-7px;" class="filter-item"
              @click="toOrderDetail(orderList[0])">订单详情</el-button>
            <el-button size="medium" type="text" v-if="orderList.length > 1"
              style="float:right;margin-top:-7px;margin-right:10px" class="filter-item"
              @click="showMoreOrder = true">更多订单</el-button>
          </h4>
          <div class="pure-g" style="margin-top:10px;">
            <div class="pure-u-1-3 el-form-item__label">
              <p>创建时间</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>
                {{
                  orderList[0].createdAt | parseTime("{y}年{m}月{d}日 {h}:{i}")
                }}
              </p>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">
              <p>订购车型</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ orderList[0].zzType === 1 ? orderList[0].modelDisplay : (orderList[0].zzType === 2 ?  orderList[0].seriesName : `${orderList[0].seriesName} ${orderList[0].modelDisplay}` ) }}</p>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">
              <p>订金</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ orderList[0].zzType === 1 ? orderList[0].paymentDown : (orderList[0].zzType === 2 ? orderList[0].PaymentMoney : orderList[0].paydownMoney)  }}</p>
            </div>
          </div>
          <!-- <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">
              <p>成交金额</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{orderList[0].paymentDeal}}</p>
            </div>
          </div> -->
          <div class="pure-g" v-if="orderList[0].deliverDate">
            <div class="pure-u-1-3 el-form-item__label">
              <p>预计交车时间</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>
                {{ orderList[0].deliverDate | parseTime("{y}年{m}月{d}日") }}
              </p>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1-3 el-form-item__label">
              <p>订单状态</p>
            </div>
            <div class="pure-u-2-3 el-form-item__content">
              <p>{{ orderList[0].zzType === 1 ? formatLabel(orderList[0].status, orderStatusList) : (orderList[0].zzType === 2 ? blindOrderStatusMap.get(orderList[0].orderStatus) : smallOrderStatusMap.get(orderList[0].orderStatus))  }}</p>
            </div>
          </div>
          <div class="pure-g" style="margin-top:10px;display:flex;justify-content:flex-end" v-if="isZZOrder(orderList[0])">
            <el-button size="small" style="margin-right:10px" @click="orderCancel" v-if="orderList[0].status === 1 ||
              orderList[0].status === 6 ||
              orderList[0].status === 11
              ">订单取消</el-button>
            <el-button size="small" v-if="orderList[0].status === 1 || orderList[0].status === 11"
              @click="handleOrderSubmit(orderList[0])">提交</el-button>
            <el-button size="small" v-if="orderList[0].status === 16"
              @click="handleRefundSubmit">审核通过</el-button>
            <!-- <el-button size="small"
                       @click="orderWithdraw"
                       v-if="orderList[0].status === 2">订单撤回</el-button> -->
          </div>
          <div class="pure-g" v-if="isZZOrder(orderList[0]) && orderList[0].extOrderId != ''"
            style="margin-top:10px;width:100%;display:flex;justify-content:flex-end;letter-spacing: 0">
            <div>APP线上下定</div>
          </div>
        </div>
      </div>
      <div style="margin-left: 400px; overflow:auto;margin-right:20px;padding:0px 20px;">
        <el-radio-group v-model="activeName" size="small" style="margin-bottom:10px;">
          <el-radio-button label="FollowRecords">跟进记录</el-radio-button>
          <el-radio-button label="CustomerDynamics">客户动态</el-radio-button>
          <el-radio-button label="CustomerProfile">客户画像</el-radio-button>
          <el-radio-button label="MediaProfile" v-if="mediaProfileUrl">垂媒画像</el-radio-button>
        </el-radio-group>
        <el-table :data="timelines" stripe v-if="activeName === 'FollowRecords'">
          <el-table-column align="left" label="时间" width="165">
            <template slot-scope="scope">{{ scope.row.createdAt | parseTime("{y}年{m}月{d}日 {h}:{i}:{s}") }}</template>
          </el-table-column>
          <el-table-column align="left" label="客户经理" width="120">
            <template slot-scope="scope">{{ scope.row.ownerName }}</template>
          </el-table-column>
          <el-table-column align="left" label="级别" width="120">
            <template slot-scope="scope">{{
              scope.row.level | levelDisplay
            }}</template>
          </el-table-column>
          <el-table-column align="left" label="事项" width="120">
            <template slot-scope="scope">{{ scope.row.subject }}</template>
          </el-table-column>
          <el-table-column align="left" label="内容" min-width="160">
            <template slot-scope="scope">
              <i v-if="scope.row.audioUrl != '' && scope.row.subject.indexOf('智慧号') < 0" class="fa fa-play-circle fa-fw fa-lg" style="cursor: pointer;"
                aria-hidden="true" @click="playAudio(scope.row.audioUrl)"></i>
              <span v-html="scope.row.content.replaceAll('\n', '<br/>')" v-if="scope.row.subject != '休眠'"></span>
              <span v-html="scope.row.content.replaceAll('\n', '')" v-if="scope.row.subject == '休眠'"></span>
              <span v-show="scope.row.onlineCustomerId > 0 &&
                scope.row.subject != '企业微信' &&
                scope.row.subject.indexOf('智慧号') < 0
                " style="margin-left: 10px;" class="click_link"
                @click="showClueDetailDialog(scope.row.onlineCustomerId)">点击查看</span>
              <span v-show="scope.row.subject.indexOf('防封号') >= 0 &&
                scope.row.audioUrl != ''
                " style="margin-left: 10px;" class="click_link" @click="showClueDetailDialog2(scope.row)">点击查看</span>
              <span v-show="scope.row.subject == '试驾分享'" style="margin-left: 10px;" class="click_link"
                @click="showtestShareDialog(scope.row.images1)">查看详情</span>
              <!-- 边界：content 为空或不含"智能总结: / 智能总结："（半角/全角冒号兼容）时不显示入口 -->
               <!--  && /智能总结[:：]/.test(scope.row.content || '') -->
              <span v-show="scope.row.subject === '企微跟进' && scope.row.wxSummary" style="margin-left: 10px;" class="click_link"
                @click="showWechatSummaryDialog(scope.row)">查看企微智能总结</span>
              <!-- 智慧号拨打客户电话：查看通话详情入口 -->
               <!-- showSmartCallDetailDialog(scope.row) -->
              <span v-if="scope.row.subject === '智慧号拨打客户电话' && scope.row.audioUrl != ''" style="margin-left: 10px;" class="click_link"
                @click="showClueDetailDialog2(scope.row, 'bydAudioUrl')">查看通话详情</span>
              <!-- 编辑入口仅王朝门店（type 1）且发起人本人可见：ownerId 须等于当前登录用户 userId -->
              <i v-if="scope.row.subject === '发起通话' && !onlyView && dealer && dealer.type === 1 && scope.row.ownerId === dealer.userId" class="el-icon-edit-outline edit-icon"
                style="cursor: pointer; margin-left: 10px;" @click="openCallEditDialog(scope.row)"></i>

            </template>
          </el-table-column>
        </el-table>
        <!-- 垂媒画像：内嵌外部系统 H5 -->
        <div v-else-if="activeName === 'MediaProfile'" style="width:100%;">
          <!-- 边界：链接未配置或加载失败时给出提示，避免空白区块 -->
          <iframe v-if="mediaProfileUrl" :src="mediaProfileUrl" style="width:100%;height:600px;border:none;"
            @load="mediaProfileLoading = false" v-loading="mediaProfileLoading"></iframe>
          <div v-else style="padding:20px;color:#909399;">暂无垂媒画像数据</div>
        </div>
        <!-- 客户动态/客户画像 -->
        <component v-else :is="activeName" :dealerId="dealer.dealerId" :customerId="customerId" :cdpTag="cdpTag" :cdpProfile=cdpProfile></component>
      </div>
    </div>
    <el-dialog title="完成跟进" :visible.sync="followDialog" width="800px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="followForm" :inline="true" label-position="right" :model="followForm" :rules="followFormRules"
        label-width="110px">
        <div class="pure-g">
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="当前跟进">
              <el-radio-group v-model="followForm.completedActivityType" size="mini">
                <el-radio-button v-for="item in activityFollowTypes" :key="item.dataValue" :label="item.dataValue">{{
                  item.dataDisplay }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>

          <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="followForm.completedActivityType == 9">
            <el-form-item class="form_item" label="沟通方式" prop="contactType">
              <el-select size="mini" style="width:160px;" v-model="followForm.contactType">
                <el-option v-for="item in contactTypes" :key="item.dataValue" :label="item.dataDisplay"
                  :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="followForm.completedActivityType == 3">
            <el-form-item class="form_item" label="试驾反馈">
              <el-radio-group v-model="followForm.testResult" size="mini">
                <el-radio-button :label="1">满意</el-radio-button>
                <el-radio-button :label="2">一般</el-radio-button>
                <el-radio-button :label="3">不满意</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="followForm.completedActivityType === 1 ||
            followForm.completedActivityType === 14 ||
            followForm.completedActivityType === 15
            ">
            <el-form-item class="form_item" label="发生事件" prop="event">
              <el-radio-group v-model="followForm.event" @change="eventChange" size="mini">
                <el-radio-button :label="1">报价</el-radio-button>
                <el-radio-button :label="2">邀约到店</el-radio-button>
                <el-radio-button :label="3">邀约试驾</el-radio-button>
                <el-radio-button :label="5">生日回访</el-radio-button>
                <el-radio-button :label="4">其他</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="followForm.event === 1 &&
            (followForm.completedActivityType === 1 ||
              followForm.completedActivityType === 14 ||
              followForm.completedActivityType === 15)
            ">
            <el-form-item class="form_item" label="报价金额">
              <el-input size="mini" v-model="followForm.quote">
                <span slot="suffix">元</span>
              </el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="(followForm.event === 2 || followForm.event === 3) &&
            (followForm.completedActivityType === 1 ||
              followForm.completedActivityType === 14 ||
              followForm.completedActivityType === 15)
            ">
            <el-form-item class="form_item" label="预约到店时间" prop="reserveComeDate">
              <el-date-picker size="mini" style="width:160px;" :picker-options="pickerOptions"
                v-model="followForm.reserveComeDate" :clearable="false" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="followForm.completedActivityType == 3">
            <el-form-item class="form_item" label="试驾车系"  prop="testSpecId" required>
              <el-select size="mini" class="filter-item" style="width: 330px;" placeholder="选择试驾车系" filterable
                v-model="followForm.testSpecId">
                <el-option v-for="item in seriesOptions" :key="item.specId" :label="item.name"
                  :value="item.specId"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="followForm.completedActivityType == 2">
            <el-form-item class="form_item" label="到店时长" prop="comeDuration">
              <el-select size="mini" style="width:160px;" v-model="followForm.comeDuration">
                <el-option v-for="item in activityComeTypes" :key="item.dataValue" :label="item.dataDisplay"
                  :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="意向车系" prop="specIds">
              <el-select size="mini" style="width: 330px;" placeholder="选择意向车系" :multiple-limit="5" multiple
                v-model="followForm.specIds" filterable>
                <el-option v-for="(item, index) in seriesOptions" :key="index" :label="item.name"
                  :value="item.specId"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="意向竞品">
              <el-select size="mini" style="width: 290px;" placeholder="选择意向竞品" :multiple-limit="5" multiple
                v-model="followForm.competitionSeries" filterable>
                <el-option v-for="(item, index) in competitionSeries" :key="index"
                  :label="item.brandName + ' ' + item.seriesName" :value="item.id" :disabled="item.disabled"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="!isFail">
            <el-form-item class="form_item" label="客户级别">
              <el-select size="mini" style="width:160px;" v-model="followForm.level" @change="changeActivityLevel">
                <el-option v-for="item in followLevelOptions" :key="item.dataName" :label="item.dataDisplay"
                  :value="item.dataName"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" v-if="!followForm.isSuspend" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="是否战败">
              <el-radio-group v-model="isFail" size="mini">
                <el-radio-button :label="true">是</el-radio-button>
                <el-radio-button :label="false">否</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="!isFail">
            <el-form-item class="form_item" label="是否休眠">
              <el-radio-group v-model="followForm.isSuspend" size="mini">
                <el-radio-button :label="true">是</el-radio-button>
                <el-radio-button :label="false">否</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="line-separator"></div>
          <div class="pure-g">
            <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="!isFail && followForm.isSuspend">
              <el-form-item class="form_item" label="自动唤醒" prop="resumeDuration">
                <el-select size="mini" style="width: 130px;" filterable v-model="followForm.resumeDuration">
                  <el-option v-for="item in customerResumeDurations" :key="item.dataValue" :label="item.dataDisplay"
                    :value="item.dataValue"></el-option>
                </el-select>
                <span class="el-form-item__label" style="margin-left:2px">后</span>
              </el-form-item>
            </div>
            <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="isFail">
              <el-form-item class="form_item" label="战败原因" prop="failReason">
                <el-select size="mini" style="width: 130px;" filterable v-model="followForm.failReason">
                  <el-option v-for="item in newFailReasons" :key="item.dataValue" :label="item.dataName"
                    :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
            </div>

            <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="(isFail && followForm.failReason == 6) ||
              followForm.failReason == 2 ||
              followForm.failReason == 3
              ">
              <el-form-item class="form_item" label="次级原因" prop="failSubReason">
                <el-select size="mini" style="width: 130px;" filterable v-model="followForm.failSubReason">
                  <el-option v-for="(item, index) in failSubReasonOption" :key="index" :label="item"
                    :value="index + 1"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="isFail &&
              followForm.failReason == 6 &&
              followForm.failSubReason == 1
              ">
              <el-form-item class="form_item" label="战败经销商">
                <el-select size="mini" style="width: 400px;" filterable v-model="followForm.failDealerName">
                  <el-option v-for="(item, index) in cityDealers" :key="index" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="isFail &&
              (followForm.failReason == 1 || followForm.failReason == 7)
              ">
              <el-form-item class="form_item" label="战败车型">
                <el-select size="mini" v-model="followForm.failSeriesId" filterable>
                  <el-option v-for="(item, index) in competitionSeries" :key="index"
                    :label="item.brandName + ' ' + item.seriesName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="pure-u-1-1" style="padding-bottom:12px;"
              v-if="isFail && (followForm.failReason == 1 || followForm.failReason == 21)">
              <el-form-item class="form_item" label="原因" :prop="isFail && (followForm.failReason == 1 || followForm.failReason == 21) ? 'failPurchaseReason' : ''">
                <el-select size="mini" style="width: 290px;" filterable v-model="followForm.failPurchaseReason" multiple>
                  <el-option v-for="(item, index) in failProductReasonDics" :key="index" :label="item.dataName"
                    :value="item.dataName"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="isFail && followForm.failReason == 15">
              <el-form-item class="form_item" label="客户意向购车城市" prop="home">
                <el-cascader v-model="followForm.home" :options="failCities" :props="{ value: 'label' }"
                  size="small"></el-cascader>
              </el-form-item>
            </div>
            <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="!isFail && !followForm.isSuspend">
              <el-form-item class="form_item" label="下次跟进">
                <el-radio-group v-model="followForm.nextActivityType"
                  :disabled="followForm.event === 2 || followForm.event === 3" size="mini">
                  <el-radio-button v-for="  item   in   activityNextFollowTypes  " :key="item.dataValue"
                    :label="item.dataValue">{{ item.dataDisplay }}</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="!isFail &&
              !followForm.isSuspend &&
              followForm.event != 2 &&
              followForm.event != 3
              ">
              <el-form-item class="form_item" label="跟进日期">
                <el-date-picker size="mini" style="width:160px;" :picker-options="pickerOptions"
                  v-model="followForm.nextDate" :clearable="false" type="date" placeholder="选择日期"></el-date-picker>
              </el-form-item>
            </div>
            <!-- <div
              class="pure-u-1-1"
              style="padding-bottom:12px;"
              v-if="followForm.nextActivityType == 3 && !isFail && !followForm.isSuspend"
            >
              <el-form-item
                class="form_item"
                label="试驾车型"
                prop="nextTestSpecId"
                :rules="followForm.nextActivityType == 3? followFormRules.nextTestSpecId: followFormRules.notRequired"
              >
                <el-select
                  size="mini"
                  class="filter-item"
                  style="width: 330px;"
                  placeholder="选择试驾车系"
                  filterable
                  v-model="followForm.nextTestSpecId"
                >
                  <el-option
                    v-for="item in seriesOptions"
                    :key="item.specId"
                    :label="item.name"
                    :value="item.specId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>-->
            <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="isFail && followForm.failReason == 5">
              <el-form-item class="form_item" label="战败原因详情" prop="failReasonDetail" required>
                <el-input type="textarea" style="width:330px;" filterable :rows="4" placeholder="请输入战败原因详情"
                  v-model="followForm.failReasonDetail" maxlength="200" show-word-limit></el-input>
              </el-form-item>
            </div>
            <div class="pure-u-1-1" style="padding-bottom:12px;">
              <el-form-item class="form_item" label="备注" prop="remark">
                <el-input type="textarea" style="width:330px;" :rows="4" placeholder="请输入备注内容"
                  v-model="followForm.remark" maxlength="200" show-word-limit></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="text" @click="dohandlePending" v-antiSnake="2000">确定</el-button>
        <el-button @click="followDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批注" :visible.sync="remarkDialog" width="350px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="remarkForm" label-position="right" :model="remarkForm" :rules="remarkFormRules" label-width="0px">
        <el-form-item class="form_item_val" prop="remark">
          <el-input type="textarea" :rows="4" placeholder="请输入批注内容" v-model="remarkForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doRemark" type="text">确定</el-button>
        <el-button @click="remarkDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="再分配" :visible.sync="assignDialog" width="350px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="assignForm" label-position="right" :model="assignForm" :rules="assignFormRules" label-width="80px">
        <el-form-item class="form_item_val" label="客户经理" prop="memberId">
          <el-select size="mini" v-model="assignForm.memberId">
            <el-option v-for="  item   in   assignMembers  " :key="item.memberId" :label="item.userName"
              :value="item.memberId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="form_item_val" label="备注">
          <el-input type="textarea" :rows="4" placeholder="请输入备注内容" v-model="assignForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doAssign" type="text">确定</el-button>
        <el-button @click="assignDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="复活" :visible.sync="reliveDialog" width="590px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="reliveForm" :inline="true" label-position="right" :model="reliveForm" :rules="reliveFormRules"
        label-width="80px">
        <div class="pure-g">
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="意向级别">
              <el-select size="mini" style="width:160px;" v-model="reliveForm.level" @change="changeReliveLevel">
                <el-option v-for="  item   in   followLevelOptions  " :key="item.dataName" :label="item.dataDisplay"
                  :value="item.dataName"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- <div class="pure-u-1-2"
               style="padding-bottom:12px;">
            <el-form-item class="form_item"
                          label="客户经理">
              <el-select v-if="members.length > 0"
                         size="mini"
                         style="width:160px;"
                         v-model="reliveForm.memberId">
                <el-option v-for="item in members"
                           :key="item.memberId"
                           :label="item.userName"
                           :value="item.memberId"></el-option>
              </el-select>
              <span v-if="members.length == 0">{{reliveForm.memberName}}</span>
            </el-form-item>
          </div> -->
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="意向车系" prop="specIds">
              <!-- <el-cascader size="mini" class="filter-item" style="width: 330px;" placeholder="选择意向车型" filterable :show-all-levels="true" :options="carOptions" v-model="reliveForm.specId">
              </el-cascader>-->
              <el-select size="mini" class="filter-item" style="width: 330px;" placeholder="选择意向车系" :multiple-limit="5"
                filterable multiple v-model="reliveForm.specIds">
                <el-option v-for="  item   in   seriesOptions  " :key="item.specId" :label="item.name"
                  :value="item.specId"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="下次跟进">
              <el-radio-group v-model="reliveForm.nextActivityType" size="mini">
                <el-radio-button v-for="  item   in   activityNextFollowTypes  " :key="item.dataValue"
                  :label="item.dataValue">{{
                    item.dataDisplay }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="跟进日期">
              <el-date-picker size="mini" style="width:160px;" v-model="reliveForm.nextDate" :clearable="false"
                type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </div>
          <!-- <div
            class="pure-u-1-1"
            style="padding-bottom:12px;"
            v-if="reliveForm.nextActivityType == 3"
          >
            <el-form-item
              class="form_item"
              label="试驾车系"
              prop="nextTestSpecId"
              :rules="reliveForm.nextActivityType == 3? reliveFormRules.nextTestSpecId: reliveFormRules.notRequired"
            >
              <el-select
                size="mini"
                class="filter-item"
                style="width: 330px;"
                placeholder="选择试驾车系"
                filterable
                v-model="reliveForm.nextTestSpecId"
              >
                <el-option
                  v-for="item in seriesOptions"
                  :key="item.specId"
                  :label="item.name"
                  :value="item.specId"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>-->
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="复活原因" prop="remark">
              <el-input type="textarea" style="width:330px;" :rows="4" placeholder="请输入复活原因"
                v-model="reliveForm.remark"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doRelive" type="text">确定</el-button>
        <el-button @click="reliveDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="完成订车" :visible.sync="orderDialog" width="600px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="orderForm" :inline="true" label-position="right" :model="orderForm" :rules="orderFormRules"
        label-width="80px">
        <div class="pure-g">
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="订购车型" prop="specId">
              <el-cascader size="mini" class="filter-item" style="width: 330px;" placeholder="选择订购车型" filterable
                :show-all-levels="true" :options="carOptions" v-model="orderForm.specId"
                @change="changeSpecColor"></el-cascader>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="交车日期" prop="deliverDate">
              <el-date-picker size="mini" style="width:160px;" v-model="orderForm.deliverDate" :clearable="false"
                type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="车辆颜色" prop="color">
              <el-select size="mini" v-model="orderForm.color" filterable>
                <el-option v-for="  item   in   orderForm.colors  " :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="购车订金" prop="downPayment">
              <el-input-number style="width:120px;" type="number" :min="0" :max="100000" size="mini" placeholder="请输入金额"
                v-model="orderForm.downPayment"></el-input-number>
              <span style="margin-left:10px;">元</span>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="成交价格" prop="price">
              <el-input-number style="width:120px;" type="number" :min="0" size="mini" placeholder="请输入金额"
                v-model="orderForm.price"></el-input-number>
              <span style="margin-left:10px;">元</span>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="付款方式">
              <el-radio-group v-model="orderForm.payType" size="mini">
                <el-radio-button :label="1">一次性</el-radio-button>
                <el-radio-button :label="2">分期</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="置办保险">
              <el-switch v-model="orderForm.payInsurance"></el-switch>
            </el-form-item>
          </div>

          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="备注">
              <el-input type="textarea" style="width:330px;" :rows="4" placeholder="请输入备注内容"
                v-model="orderForm.remark"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doOrder" type="text" v-antiSnake="1500">确定</el-button>
        <el-button @click="orderDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="完成交车" :visible.sync="deliverDialog" width="600px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="deliverForm" :inline="true" label-position="right" :model="deliverForm" :rules="deliverFormRules"
        label-width="80px">
        <div class="pure-g">
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="订购车型" prop="specId">
              <el-cascader size="mini" class="filter-item" style="width: 330px;" placeholder="选择订购车型" filterable
                :show-all-levels="true" :options="carOptions" v-model="deliverForm.specId"
                @change="changeSpecColor"></el-cascader>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="车辆颜色" prop="color">
              <el-select size="mini" v-model="deliverForm.color" filterable>
                <el-option v-for="  item   in   deliverForm.colors  " :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="购车订金">
              <el-input-number style="width:120px;" type="number" :min="0" :max="100000" size="mini" placeholder="请输入金额"
                v-model="deliverForm.downPayment"></el-input-number>
              <span style="margin-left:10px;">元</span>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="成交价格">
              <el-input-number style="width:120px;" type="number" :min="0" size="mini" placeholder="请输入金额"
                v-model="deliverForm.price"></el-input-number>
              <span style="margin-left:10px;">元</span>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="付款方式">
              <el-radio-group v-model="deliverForm.payType" size="mini">
                <el-radio-button :label="1">一次性</el-radio-button>
                <el-radio-button :label="2">分期</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="置办保险">
              <el-switch v-model="deliverForm.payInsurance"></el-switch>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="是否下次回访">
              <el-switch v-model="deliverForm.nextRecall"></el-switch>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="deliverForm.nextRecall">
            <el-form-item class="form_item" label="跟进日期">
              <el-date-picker size="mini" style="width:160px;" v-model="deliverForm.nextDate" :clearable="false"
                type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="备注">
              <el-input type="textarea" style="width:330px;" :rows="4" placeholder="请输入备注内容"
                v-model="deliverForm.remark"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doDeliver" type="text">确定</el-button>
        <el-button @click="deliverDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="完成回访" :visible.sync="recallDialog" width="570px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="recallForm" :inline="true" label-position="right" :model="recallForm" :rules="recallFormRules"
        label-width="100px">
        <div class="pure-g">
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="回访结果">
              <el-radio-group v-model="recallForm.contactStatus" size="mini">
                <el-radio-button :label="1">已联系</el-radio-button>
                <el-radio-button :label="2">未联系上</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="是否下次回访">
              <el-switch v-model="recallForm.nextRecall"></el-switch>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="是否生日回访">
              <el-switch v-model="recallForm.birthdayRecall"></el-switch>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="recallForm.nextRecall">
            <el-form-item class="form_item" label="跟进日期">
              <el-date-picker size="mini" style="width:160px;" :picker-options="pickerOptions"
                v-model="recallForm.nextDate" :clearable="false" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="备注">
              <el-input type="textarea" style="width:330px;" :rows="4" placeholder="请输入备注内容"
                v-model="recallForm.remark"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doRecall" type="text">确定</el-button>
        <el-button @click="recallDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="驳回战败" :visible.sync="rejectFailDialog" width="570px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="rejectFailForm" :inline="true" label-position="right" :model="rejectFailForm"
        :rules="rejectFailFormRules" label-width="80px">
        <div class="pure-g">
          <div class="pure-u-1-1">
            <el-form-item class="form_item" label="战败原因">{{
              failInfo.reason
            }}</el-form-item>
          </div>
          <div class="pure-u-1-1">
            <el-form-item class="form_item" label="备注">{{
              failInfo.remark
            }}</el-form-item>
          </div>
          <div class="pure-u-1-1">
            <el-form-item class="form_item" label="跟进次数">{{
              failInfo.followTimes
            }}</el-form-item>
          </div>
        </div>
        <div class="line-separator" style="margin-top:10px;"></div>
        <div class="pure-g">
          <!-- <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="意向级别">
              <el-select
                size="mini"
                style="width:160px;"
                v-model="rejectFailForm.level"
                @change="changeRejectFailLevel"
              >
                <el-option
                  v-for="item in followLevelOptions"
                  :key="item.dataName"
                  :label="item.dataDisplay"
                  :value="item.dataName"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>-->
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="交叉回访" prop="crossRecall">
              <el-radio-group v-model="rejectFailForm.crossRecall" size="mini" @change="changeCross">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="客户经理">
              <el-select size="mini" style="width:160px;" v-model="rejectFailForm.memberId" @change="changeMember">
                <el-option v-for="  item   in   rejectFailMembers  " :key="item.memberId" :label="item.userName"
                  :value="item.memberId"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="跟进日期">
              <el-date-picker size="mini" style="width:160px;" v-model="rejectFailForm.nextDate" :clearable="false"
                type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="意向车系">
              <el-select size="mini" class="filter-item" style="width: 330px;" multiple disabled
                v-model="rejectFailForm.specIds">
                <el-option v-for="(item,index) in seriesOptions" :key="index" :label="item.name"
                  :value="item.specId"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- <div
            class="pure-u-1-1"
            style="padding-bottom:12px;"
            v-if="rejectFailForm.nextActivityType == 3"
          >
            <el-form-item
              class="form_item"
              label="试驾车型"
              prop="nextTestSpecId"
              :rules="rejectFailForm.nextActivityType == 3? rejectFailFormRules.nextTestSpecId: rejectFailFormRules.notRequired"
            >
              <el-select
                size="mini"
                class="filter-item"
                style="width: 330px;"
                placeholder="选择试驾车系"
                filterable
                v-model="rejectFailForm.nextTestSpecId"
              >
                <el-option
                  v-for="item in seriesOptions"
                  :key="item.specId"
                  :label="item.name"
                  :value="item.specId"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>-->
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="驳回原因">
              <el-input type="textarea" style="width:330px;" :rows="4" placeholder="请输入驳回原因"
                v-model="rejectFailForm.remark"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doRejectFail" type="text">确定</el-button>
        <el-button @click="rejectFailDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="客户画像" :visible.sync="tagDialog" width="570px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <div style="margin-bottom:5px;" v-for="category in customerTags  " :key="category.id">
        <div style="font-size:13px; font-weight: 500;line-height:30px;">
          {{ category.dataName }}
        </div>
        <el-tag style="margin-right:3px;margin-bottom:3px;cursor: pointer;"
          :type="tags.join(' ').indexOf(item) == -1 ? '' : 'success'" size="small"
          v-for="  item   in   category.dataDisplay.split(' ')  " :key="item" @click.native="checkTag(item, category)">{{
            item
          }}</el-tag>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doSaveTag" type="text">确定</el-button>
        <el-button @click="tagDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="客户编辑" :visible.sync="editDialog" width="900px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="editForm" :inline="true" label-position="right" :model="editForm" :rules="editFormRules"
        label-width="95px">
        <div class="pure-g">
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="姓名" prop="name">
              <el-input size="mini" style="width: 160px;" v-model="editForm.name"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="手机号" :prop="isNoPhone ? '' : 'mobile'">
              <el-input size="mini" style="width: 160px;" v-model="editForm.mobile"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="微信号">
              <el-input size="mini" style="width: 160px;" v-model="editForm.weixin"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="性别">
              <el-radio-group v-model="editForm.gender" size="mini">
                <el-radio-button :label="1">先生</el-radio-button>
                <el-radio-button :label="2">女士</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="上牌类型">
              <el-radio-group v-model="editForm.type" size="mini">
                <el-radio-button :label="1">个人</el-radio-button>
                <el-radio-button :label="2">企业</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;" v-show="editForm.type == 2">
            <el-form-item class="form_item" label="企业名称" prop="companyName"
              :rules="editForm.type == 2 ? editFormRules.companyName : []">
              <el-input size="mini" style="width: 160px;" v-model="editForm.companyName"></el-input>
            </el-form-item>
          </div>
          <!-- <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="客户来源">
              <el-select v-if="editForm.fromType == 2" size="mini" style="width:160px;" v-model="editForm.fromSource">
                <el-option v-for="item in fromSourceOptions" :key="item.id" :label="item.dataDisplay" :value="item.dataValue" :disabled="item.disabled"></el-option>
              </el-select>
              <span v-if="editForm.fromType == 1">{{
                editForm.onlineSourceName
              }}</span>
            </el-form-item>
          </div> -->
          <div class="pure-u-1-3" style="padding-bottom:12px;"
            v-show="editForm.fromSource == 98 || editForm.fromSource == 99">
            <el-form-item class="form_item" :label="editForm.fromSource == 98 ? '网络来源' : '自定义来源'">
              <el-select size="mini" style="width:160px;" v-model="editForm.otherSource" clearable>
                <el-option v-for="  item   in   customizationList  " :key="item.id" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="购车类型">
              <el-select size="mini" style="width:160px;" v-model="editForm.businessType">
                <el-option v-for="  item   in   businessTypeOptions  " :key="item.dataValue" :label="item.dataDisplay"
                  :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;"
            v-if="editForm.businessType == 2 || editForm.businessType == 3">
            <el-form-item class="form_item" label="原车信息">
              <el-select size="mini" style="width: 290px;" placeholder="选择原车信息" v-model="editForm.addPurchaseOldSeriesId"
                filterable>
                <el-option v-for="(  item, index  ) in   competitionSeriesesOptions  " :key="index"
                  :label="item.brandName + ' ' + item.seriesName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;" v-if="editForm.businessType == 4">
            <el-form-item class="form_item" label="采购数量">
              <el-input-number size="mini" v-model="editForm.buyCount" :min="0" :max="10000"></el-input-number>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="其他联系号码">
              <el-input size="mini" style="width: 160px;" v-model="editForm.secondardPhone"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="更多">
              <el-switch v-model="value1"></el-switch>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;" v-show="value1">
            <el-form-item class="form_item" label="省/市/区">
              <el-select size="mini" style="width:100px;" placeholder="选择省" clearable @change="provinceChange"
                v-model="editForm.addition.province">
                <el-option v-for="  item   in   provinces  " :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-select size="mini" style="width:100px;" placeholder="选择市" clearable @change="cityChange"
                v-model="editForm.addition.city">
                <el-option v-for="  item   in   citys  " :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-select size="mini" style="width:100px;" placeholder="选择区" clearable v-model="editForm.addition.area">
                <el-option v-for="  item   in   countys  " :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <!-- <div class="pure-u-1-2"
               style="padding-bottom:12px;"
               v-show="value1">
            <el-form-item class="form_item"
                          label="所在地">
              <el-cascader v-model="home"
                           :options="homeOptions"
                           :props="props"
                           size="small"></el-cascader>
            </el-form-item>
          </div> -->
          <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value1">
            <el-form-item class="form_item" label="联系地址">
              <el-input size="mini" style="width: 200px;" v-model="editForm.addition.address"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value1">
            <el-form-item class="form_item" label="证件类型" prop="identifyType">
              <el-select size="mini" @change="identifyTypeChange" style="width:160px;" placeholder="请选择"
                v-model="editForm.identifyType">
                <el-option v-for="  item   in   orderIdentifyTypeDics  " :key="item.dataValue" :label="item.dataDisplay"
                  :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value1">
            <el-form-item class="form_item" v-if="editForm.identifyType === 1" label="证件号码" prop="identifyNo">
              <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="editForm.identifyNo"></el-input>
            </el-form-item>
            <el-form-item class="form_item" v-if="editForm.identifyType === 2" label="证件号码" prop="identifyNo2">
              <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="editForm.identifyNo2"></el-input>
            </el-form-item>
            <el-form-item class="form_item" v-if="editForm.identifyType === 3" label="证件号码" prop="identifyNo3">
              <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="editForm.identifyNo3"></el-input>
            </el-form-item>
            <el-form-item class="form_item" v-if="editForm.identifyType != 1 &&
              editForm.identifyType != 2 &&
              editForm.identifyType != 3
              " label="证件号码" prop="identifyNos">
              <el-input size="mini" style="width: 160px;" placeholder="请输入" v-model="editForm.identifyNos"></el-input>
            </el-form-item>
          </div>
          <!-- <div class="pure-u-1-3"
               style="padding-bottom:12px;"
               v-show="value1">
            <el-form-item class="form_item"
                          label="身份证">
              <el-input size="mini"
                        style="width: 160px;"
                        v-model="editForm.addition.idNo"></el-input>
            </el-form-item>
          </div> -->
          <div class="pure-u-1-3" style="padding-bottom:12px;" v-show="value1">
            <el-form-item class="form_item" label="生日">
              <el-date-picker size="mini" style="width:160px;" v-model="editForm.addition.birthday" :clearable="false"
                type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;" v-show="value1">
            <el-form-item class="form_item" label="QQ">
              <el-input size="mini" style="width: 160px;" v-model="editForm.addition.qq"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-2 buy-car-address" style="padding-bottom:12px;">
            <el-form-item class="form_item" prop="buyCarAddress">
              <div slot="label">
                <span style="color: #f56c6c;margin-right: 4px;">*</span>
                <span>购车地区</span>
                <el-popover
                  placement="top-start"
                  title=""
                  width="210"
                  trigger="hover"
                  content="若购车地区与本门店所属市不同，系统会将其标记为“异地购车”">
                  <i slot="reference" style="margin-left: 5px;" class="el-icon-question"></i>
                </el-popover>
                
              </div>
              <el-select size="mini" style="width:100px;" placeholder="选择省" clearable @change="changeBuyCarProvince"
                v-model="editForm.buyProvince">
                <el-option v-for="item in provinces" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-select size="mini" style="width:100px;" placeholder="选择市" clearable @change="changeBuyCarCity"
                v-model="editForm.buyCity">
                <el-option v-for="item in buyCarCityList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-select size="mini" style="width:100px;" placeholder="选择区" clearable @change="changeBuyCarArea" v-model="editForm.buyArea">
                <el-option v-for="item in buyCarAreaList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="购车预算">
              <el-select size="mini" style="width:160px;" v-model="editForm.budget">
                <el-option v-for="  item   in   budgetOptions  " :key="item.dataValue" :label="item.dataDisplay"
                  :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="预计购车时间" label-width="90px" style="margin-right: 5px;">
              <el-date-picker size="mini" style="width:160px;" v-model="editForm.buycarDate" :clearable="false"
                type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <div style="font-size: 13px;display:inline-block;height: 100%;line-height: 28px;">
              之前
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doUpdate" type="text" v-antiSnake="1500">保存</el-button>
        <el-button @click="editDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="线索详情" :visible.sync="clueDetailDialog" width="650px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="clueDetailForm" label-position="right" :model="clueDetailForm" label-width="100px">
        <div class="pure-g">
          <div class="pure-u-1-2">
            <el-form-item class="form_item" label="姓名">{{
              clueDetailForm.name
            }}</el-form-item>
            <el-form-item class="form_item" label="手机号">{{
              clueDetailForm.phone
            }}</el-form-item>
            <el-form-item class="form_item" label="微信号">{{
              clueDetailForm.wechatId
            }}</el-form-item>
            <el-form-item class="form_item" label="意向车系">
              {{ clueDetailForm.mappingSpecId == 0 ? clueDetailForm.seriesName: clueDetailForm.mappingSeriesName }}
            </el-form-item>
            <el-form-item class="form_item" label="归属地">{{
              clueDetailForm.province + "/" + clueDetailForm.city
            }}</el-form-item>
            <el-form-item class="form_item" label="来源平台">{{
              clueDetailForm.sourceName
            }}</el-form-item>
            <el-form-item class="form_item" label="线索创建时间">{{
              clueDetailForm.createTime
            }}</el-form-item>
            <el-form-item class="form_item" label="线索类别">{{
              clueDetailForm.clueLevel == 1 ? "一类" : "二类"
            }}</el-form-item>
            <el-form-item class="form_item" label="参与活动" v-if="clueDetailForm.activityDesc">{{ clueDetailForm.activityDesc
            }}</el-form-item>
            <el-form-item class="form_item" label="营销备注" v-if="clueDetailForm.marketingRemark">{{ clueDetailForm.marketingRemark }}</el-form-item>
            <el-form-item class="form_item" label="线上已付金额" v-if="clueDetailForm.paymentMoney > 0">{{
              clueDetailForm.paymentMoney / 100 }}元</el-form-item>
          </div>
          <div class="pure-u-1-2" style="overflow-y:auto;">
            <div class="pure-g" v-for="(item, index) in clueTimelines" :key="item.id">
              <div class="pure-u-1-1 el-form-item__label" style="text-align:left;">
                {{ item.createdAt | parseTime("{y}-{m}-{d} {h}:{i}") }}
              </div>
              <div class="pure-u-1-1 el-form-item__content" style="padding-left:20px;">
                <p style="line-height:20px;">
                  处理人员: {{ item.handleOwnerName }}
                </p>
                <p style="line-height:20px;">处理结果: {{ item.result }}</p>
                <p style="line-height:20px;" v-if="item.followOwnerName != ''">
                  跟进人员: {{ item.followOwnerName }}
                </p>
                <p style="display: flex;line-height:20px;" v-if="item.remark">
                  <span style="width: 32px">备注: </span>
                  <span style="flex: 1;" v-html="item.remark.replaceAll('\n', '<br/>')"></span>
                </p>
                 <p style="display: flex;line-height:20px;" v-if="item.remarkPic && item.remarkPic.length > 0">
                  <span style="width: 96px">客户微信截图: </span>
                  <span>
                    <Upload v-model="item.remarkPic" disabled isMini >
                    </Upload>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clueDetailDialog = false" type="text">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 企微智能总结弹框 -->
    <el-dialog title="企微智能总结" :visible.sync="wechatSummaryDialog" width="500px" :close-on-press-escape="false"
      :close-on-click-modal="false" class="wechat-summary-dialog">
      <div style="max-height: 400px; overflow-y: auto;">
        <pre style="white-space: pre-wrap; word-wrap: break-word; font-family: inherit;">{{ wechatSummaryContent }}</pre>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="wechatSummaryDialog = false" type="text">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 智慧号通话详情弹框 -->
    <el-dialog title="通话详情" :visible.sync="smartCallDetailDialog" width="500px" :close-on-press-escape="false"
      :close-on-click-modal="false" class="smart-call-detail-dialog">
      <div style="max-height: 400px; overflow-y: auto;">
        <pre style="white-space: pre-wrap; word-wrap: break-word; font-family: inherit;">{{ smartCallDetailContent }}</pre>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="smartCallDetailDialog = false" type="text">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 通话记录编辑弹框 -->
    <el-dialog title="跟进内容" :visible.sync="callEditDialog" width="600px" :close-on-press-escape="true"
      :close-on-click-modal="false" @close="handleCallEditDialogClose" class="call-edit-dialog">
      <el-form ref="callEditFormRef" :model="callEditForm" label-width="80px">
        <el-form-item labelWidth="0">
          <el-input type="textarea" v-model="callEditForm.content" :rows="6" :maxlength="200"
            placeholder="请输入跟进内容（最多200字）" @keyup.ctrl.enter.native="handleCallEditSave"></el-input>
          <div class="word-count-tip">
            <span :class="{ 'word-limit-warning': callEditForm.content.length >= 200 }">
              {{ callEditForm.content.length }}/200
            </span>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="callEditDialog = false" type="text">取消</el-button>
        <el-button @click="handleCallEditSave" :loading="callEditLoading" type="text">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="再次购车" :visible.sync="newDialog" width="900px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="newForm" :inline="true" label-position="right" :model="newCustomer" :rules="newCustomerRules"
        label-width="95px">
        <div class="pure-g">
          <div class="add-title">客户信息</div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="姓名" prop="name">
              <el-input size="mini" style="width: 160px;" v-model="newCustomer.name"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="手机号" prop="mobile">
              <el-input size="mini" style="width: 160px;" v-model="newCustomer.mobile" readonly></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="微信号">
              <el-input size="mini" style="width: 160px;" v-model="newCustomer.weixin"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="性别" prop="gender">
              <el-radio-group v-model="newCustomer.gender" size="mini">
                <el-radio-button :label="1">先生</el-radio-button>
                <el-radio-button :label="2">女士</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="上牌类型">
              <el-radio-group v-model="newCustomer.type" size="mini">
                <el-radio-button :label="1">个人</el-radio-button>
                <el-radio-button :label="2">企业</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;" v-show="newCustomer.type == 2">
            <el-form-item class="form_item" label="企业名称" prop="companyName" :rules="newCustomer.type == 2
              ? newCustomerRules.companyName
              : newCustomerRules.notRequired
              ">
              <el-input size="mini" style="width: 160px;" v-model="newCustomer.companyName"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="客户来源">
              <el-select size="mini" style="width:160px;" v-model="newCustomer.fromSource">
                <el-option v-for="item in  newFromSourceOptions" :key="item.id" :label="item.dataDisplay"
                  :value="item.dataValue" :disabled="item.disabled"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;" v-show="newCustomer.fromSource == 98 || newCustomer.fromSource == 99
            ">
            <el-form-item class="form_item" :label="newCustomer.fromSource == 98 ? '网络来源' : '自定义来源'">
              <el-select size="mini" style="width:160px;" v-model="newCustomer.otherSource" clearable>
                <el-option v-for="  item   in   customizationList  " :key="item.id" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="其他联系号码">
              <el-input size="mini" style="width: 160px;" v-model="newCustomer.secondardPhone"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="更多">
              <el-switch v-model="value2"></el-switch>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value2">
            <el-form-item class="form_item" label="所在地">
              <el-cascader v-model="home" :options="homeOptions" :props="props" size="small"></el-cascader>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;" v-show="value2">
            <el-form-item class="form_item" label="联系地址">
              <el-input size="mini" style="width: 200px;" v-model="newCustomer.addition.address"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;" v-show="value2">
            <el-form-item class="form_item" label="身份证">
              <el-input size="mini" style="width: 160px;" v-model="newCustomer.addition.idNo"></el-input>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;" v-show="value2">
            <el-form-item class="form_item" label="生日">
              <el-date-picker size="mini" style="width:160px;" v-model="newCustomer.addition.birthday" :clearable="false"
                type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </div>
          <div class="pure-u-1-3" style="padding-bottom:12px;" v-show="value2">
            <el-form-item class="form_item" label="QQ">
              <el-input size="mini" style="width: 160px;" v-model="newCustomer.addition.qq"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="pure-g">
          <div class="add-title">购车意向</div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="意向车系" prop="specIds">
              <el-select size="mini" style="width: 290px;" placeholder="选择意向车系" multiple :multiple-limit="5"
                v-model="newCustomer.specIds" filterable>
                <el-option v-for="(item, index) in seriesOptions  " :key="index" :label="item.name"
                  :value="item.specId"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="意向竞品">
              <el-select size="mini" style="width: 290px;" placeholder="选择意向竞品" :multiple-limit="5" multiple
                v-model="newCustomer.competitionSerieses" filterable>
                <el-option v-for="(item, index) in  competitionSeriesesOptions  " :key="index"
                  :label="item.brandName + ' ' + item.seriesName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2 buy-car-address" style="padding-bottom:12px;">
            <el-form-item class="form_item" prop="buyCarAddress">
              <div slot="label">
                <span style="color: #f56c6c;margin-right: 4px;">*</span>
                <span>购车地区</span>
                <el-popover
                  placement="top-start"
                  title=""
                  width="210"
                  trigger="hover"
                  content="若购车地区与本门店所属市不同，系统会将其标记为“异地购车”">
                  <i slot="reference" style="margin-left: 5px;" class="el-icon-question"></i>
                </el-popover>
                
              </div>
              <el-select size="mini" style="width:100px;" placeholder="选择省" clearable @change="changeReBuyCarProvince"
                v-model="newCustomer.buyProvince">
                <el-option v-for="item in provinces" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-select size="mini" style="width:100px;" placeholder="选择市" clearable @change="changeReBuyCarCity"
                v-model="newCustomer.buyCity">
                <el-option v-for="item in reBuyCarCityList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-select size="mini" style="width:100px;" placeholder="选择区" clearable @change="changeReBuyCarArea" v-model="newCustomer.buyArea">
                <el-option v-for="item in reBuyCarAreaList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="购车类型">
              <el-select size="mini" style="width:160px;" v-model="newCustomer.businessType">
                <el-option v-for="  item   in   businessTypeOptions  " :key="item.dataValue" :label="item.dataDisplay"
                  :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;" v-if="newCustomer.businessType == 4">
            <el-form-item class="form_item" label="采购数量">
              <el-input-number size="mini" v-model="newCustomer.buyCount" :min="0" :max="10000"></el-input-number>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="意向级别">
              <el-select size="mini" style="width:160px;" v-model="newCustomer.level" @change="changeLevel">
                <el-option v-for="  item   in   followLevelOptions  " :key="item.dataName" :label="item.dataDisplay"
                  :value="item.dataName"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="购车预算">
              <el-select size="mini" style="width:160px;" v-model="newCustomer.budget">
                <el-option v-for="  item   in   budgetOptions  " :key="item.dataValue" :label="item.dataDisplay"
                  :value="item.dataValue"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="预计购车时间" label-width="90px" style="margin-right: 5px;">
              <el-date-picker size="mini" style="width:160px;" v-model="newCustomer.buycarDate" :clearable="false"
                type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <div style="font-size: 13px;display:inline-block;height: 100%;line-height: 28px;">
              之前
            </div>
          </div>
        </div>
        <div class="pure-g">
          <div class="add-title">下次跟进计划</div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="跟进方式">
              <el-radio-group size="small" v-model="newCustomer.nextActivityType">
                <el-radio-button v-for="  item   in   activityNextFollowTypes  " :key="item.dataValue"
                  :label="item.dataValue">{{
                    item.dataDisplay }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="跟进日期">
              <el-date-picker size="mini" style="width:160px;" v-model="newCustomer.nextDate" :clearable="false"
                type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="备注">
              <el-input type="textarea" style="width:330px;" :rows="2" placeholder="请输入备注内容"
                v-model="newCustomer.remark"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doAdd" type="text">保存</el-button>
        <el-button @click="newDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="战败" :visible.sync="failDialog" width="590px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="failForm" label-position="left" :model="failForm" label-width="80px">
        <div class="pure-u-1-1" style="padding-bottom:12px;">
          <el-form-item class="form_item" label="战败原因">
            <el-select size="mini" style="width: 130px;" filterable v-model="failForm.failReason">
              <el-option v-for="  item   in   newFailReasons  " :key="item.dataValue" :label="item.dataName"
                :value="item.dataValue"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="failForm.failReason == 6 ||
          failForm.failReason == 2 ||
          failForm.failReason == 3
          ">
          <el-form-item class="form_item" label="次级原因">
            <el-select size="mini" style="width: 130px;" filterable v-model="failForm.failSubReason">
              <el-option v-for="(  item, index  ) in   failSubReasonOption  " :key="index" :label="item"
                :value="index + 1"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="pure-u-1-1" style="padding-bottom:12px;"
          v-if="failForm.failReason == 6 && failForm.failSubReason == 1">
          <el-form-item class="form_item" label="战败经销商">
            <el-select size="mini" style="width: 400px;" filterable v-model="failForm.failDealerName">
              <el-option v-for="(  item, index  ) in   cityDealers  " :key="index" :label="item"
                :value="item"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="failForm.failReason == 1 || failForm.failReason == 7">
          <el-form-item class="form_item" label="战败车型">
            <el-select size="mini" v-model="failForm.failSeriesId" filterable>
              <el-option v-for="  item   in   competitionSeries  " :key="item.id"
                :label="item.brandName + ' ' + item.seriesName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="pure-u-1-1" style="padding-bottom:12px;" v-if="failForm.failReason == 5">
          <el-form-item class="form_item" label="战败原因详情" prop="failReasonDetail" filterable>
            <el-input type="textarea" style="width:330px;" filterable :rows="4" placeholder="请输入战败原因详情"
              v-model="failForm.failReasonDetail" maxlength="200" show-word-limit></el-input>
          </el-form-item>
        </div>
        <el-form-item class="form_item_val" label="备注">
          <el-input type="textarea" :rows="4" placeholder="请输入备注内容" v-model="failForm.remark" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doFail" type="text">确定</el-button>
        <el-button @click="failDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="试驾信息" :visible.sync="testShareDetailDialog" width="650px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="clueDetailForm" label-position="right" :model="testShareDetailForm" label-width="100px">
        <div class="pure-g">
          <div class="pure-u-1-2">
            <el-form-item class="form_item" label="试驾车系">{{
              testShareDetailForm.testSeries
            }}</el-form-item>
            <el-form-item class="form_item" label="到店时间">{{
              testShareDetailForm.testDate
            }}</el-form-item>
          </div>
          <div class="pure-u-1-2" style="height:200px;overflow-y:auto;">
            <div class="pure-g" v-for="  item   in   testShareTimelines  " :key="item.id">
              <div class="pure-u-1-1 el-form-item__label" style="text-align:left;">
                {{ item.createdAt | parseTime("{y}-{m}-{d} {h}:{i}") }}
              </div>
              <div class="pure-u-1-1 el-form-item__content" style="padding-left:20px;">
                <p v-html="item.content.replaceAll('\n', '<br/>')"></p>
                <!-- <p style="line-height:20px;">处理人员: {{item.handleOwnerName}}</p>
                <p
                  style="line-height:20px;"
                  v-if="item.followOwnerName != ''"
                >跟进人员: {{item.followOwnerName}}</p>
                <p style="line-height:20px;" v-if="item.remark != ''">备注: {{item.remark}}</p> -->
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="testShareDetailDialog = false" type="text">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="购车订单" :visible.sync="showMoreOrder" width="600px" class="orderLog" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <div v-for="(  item, index  ) in   orderList  " :key="index" class="orderBox">
        <div class="pure-g" style="margin-top:10px;">
          <div class="pure-u-1-3 el-form-item__label">
            <p>创建时间</p>
          </div>
          <div class="pure-u-2-3 el-form-item__content">
            <p>{{ item.createdAt | parseTime("{y}年{m}月{d}日 {h}:{i}") }}</p>
          </div>
        </div>
        <div class="pure-g">
          <div class="pure-u-1-3 el-form-item__label">
            <p>订购车型</p>
          </div>
          <div class="pure-u-2-3 el-form-item__content">
            <p>{{ item.zzType === 1 ? item.modelDisplay : (item.zzType === 2 ? item.seriesName : `${item.seriesName} ${item.modelDisplay}` )  }}</p>
          </div>
        </div>
        <div class="pure-g">
          <div class="pure-u-1-3 el-form-item__label">
            <p>订金</p>
          </div>
          <div class="pure-u-2-3 el-form-item__content">
            <p>{{ item.zzType === 1 ? item.paymentDown : (item.zzType === 2 ? item.PaymentMoney : item.paydownMoney)  }}</p>
          </div>
        </div>
        <div class="pure-g" v-if="item.deliverDate">
          <div class="pure-u-1-3 el-form-item__label">
            <p>预计交车时间</p>
          </div>
          <div class="pure-u-2-3 el-form-item__content">
            <p>{{ item.deliverDate | parseTime("{y}年{m}月{d}日") }}</p>
          </div>
        </div>
        <div class="pure-g">
          <div class="pure-u-1-3 el-form-item__label">
            <p>订单状态</p>
          </div>
          <div class="pure-u-2-3 el-form-item__content">
            <p>{{ item.zzType === 1 ? formatLabel(item.status, orderStatusList) : (item.zzType === 2 ? blindOrderStatusMap.get(item.orderStatus) : smallOrderStatusMap.get(item.orderStatus)) }}</p>
          </div>
        </div>
        <div v-if="isZZOrder(item) && item.extOrderId != ''" class="appo">app线上下定</div>
        <div class="detail" @click="toOrderDetail(item)">订单详情</div>
      </div>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="showMoreOrder2" width="600px" class="orderLog" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <p>该客户下有"待提交"订单等待处理，请勿重复创建</p>
      <br />
      <div v-for="(  item, index  ) in   orderList2  " :key="index" class="orderBox">
        <div class="pure-g" style="margin-top:10px;">
          <div class="pure-u-1-3 el-form-item__label">
            <p>创建时间</p>
          </div>
          <div class="pure-u-2-3 el-form-item__content">
            <p>{{ item.createdAt | parseTime("{y}年{m}月{d}日 {h}:{i}") }}</p>
          </div>
        </div>
        <div class="pure-g">
          <div class="pure-u-1-3 el-form-item__label">
            <p>订购车型</p>
          </div>
          <div class="pure-u-2-3 el-form-item__content">
            <p>{{ item.modelDisplay }}</p>
          </div>
        </div>
        <div class="pure-g" v-if="item.deliverDate">
          <div class="pure-u-1-3 el-form-item__label">
            <p>预计交车时间</p>
          </div>
          <div class="pure-u-2-3 el-form-item__content">
            <p>{{ item.deliverDate | parseTime("{y}年{m}月{d}日") }}</p>
          </div>
        </div>
        <div class="pure-g">
          <div class="pure-u-1-3 el-form-item__label">
            <p>订单状态</p>
          </div>
          <div class="pure-u-2-3 el-form-item__content">
            <p>{{ formatLabel(item.status, orderStatusList) }}</p>
          </div>
        </div>
        <div class="detail" @click="toOrderDetail(item)">订单详情</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toOrder2" type="text">忽略</el-button>
        <el-button @click="toOrder3" type="text">立即处理</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="showMoreOrder3" width="610px" class="orderLog" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <p>
        该客户下有未处理订单，不允许操作战败/休眠，如要战败/休眠客户，请取消订单。请知晓!
      </p>
      <br />
      <div v-for="(  item, index  ) in   orderList3  " :key="index" class="orderBox">
        <div class="pure-g" style="margin-top:10px;">
          <div class="pure-u-1-3 el-form-item__label">
            <p>创建时间</p>
          </div>
          <div class="pure-u-2-3 el-form-item__content">
            <p>{{ item.createdAt | parseTime("{y}年{m}月{d}日 {h}:{i}") }}</p>
          </div>
        </div>
        <div class="pure-g">
          <div class="pure-u-1-3 el-form-item__label">
            <p>订购车型</p>
          </div>
          <div class="pure-u-2-3 el-form-item__content">
            <p>{{ item.modelDisplay }}</p>
          </div>
        </div>
        <div class="pure-g" v-if="item.deliverDate">
          <div class="pure-u-1-3 el-form-item__label">
            <p>预计交车时间</p>
          </div>
          <div class="pure-u-2-3 el-form-item__content">
            <p>{{ item.deliverDate | parseTime("{y}年{m}月{d}日") }}</p>
          </div>
        </div>
        <div class="pure-g">
          <div class="pure-u-1-3 el-form-item__label">
            <p>订单状态</p>
          </div>
          <div class="pure-u-2-3 el-form-item__content">
            <p>{{ formatLabel(item.status, orderStatusList) }}</p>
          </div>
        </div>
        <div class="detail" @click="toOrderDetail(item)">订单详情</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toOrder4" type="text">处理订单</el-button>
        <el-button @click="showMoreOrder3 = false" type="text">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="取消订单" :visible.sync="orderCancelLog" width="500px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="orderCancelForm" :rules="orderCancelRules" label-position="right" :model="orderCancelForm"
        label-width="80px">
        <el-row>
          <el-form-item class="form_item_val" label="取消原因" prop="reason">
            <el-input type="textarea" :rows="4" placeholder="请输入取消订单原因" v-model="orderCancelForm.reason"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderCancelLog = false" type="text">取消</el-button>
        <el-button @click="orderCanceConfim" type="text" :loading="confirmLoading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 提交审批 -->
    <el-dialog :visible.sync="SubmitLog" width="500px" title="是否提交管理层进行审批">
      <el-form label-position="left" label-width="80px" v-if="orderList[0] && orderList[0].extOrderId != '' && (!customerOrder.isLocked || isUpdate)">
        <el-form-item class="form_item" label="核销码" prop="reason">
          <el-input placeholder="请输入" size="mini" style="width:200px" v-model="code"></el-input>
          <el-button @click="sendSms" v-show="isSend" type="primary" size="mini">发送</el-button>
          <el-button v-show="!isSend" type="primary" size="mini" disabled>{{ time }}s后重新发送</el-button>
        </el-form-item>
        <p class="pss">
          点击发送将发送核销码给到订单手机号码或客户“比亚迪汽车”小程序系统通知中
        </p>
        <div class="pss">{{ remark }}</div>
      </el-form>
      <div class="submit-fo" style="padding-bottom:10px">
        <el-button @click="SubmitLog = false" size="mini">取消</el-button>
        <el-button type="primary" style="margin-left:25px!important;" @click="Submit" :loading="subLoading" size="mini">
          确定</el-button>
      </div>
    </el-dialog>

    <!-- <el-dialog :visible.sync="SubmitLog" width="20%" :center="true" title="是否提交管理层进行审批">
      <div class="submit-fo">
        <el-button @click="SubmitLog = false" size="mini">取消</el-button>
        <el-button type="primary" style="margin-left:25px!important;" @click="orderSubmit" size="mini">确定</el-button>
      </div>
      <div class="ps">注：提交审批后，订单信息将不能修改！</div>
    </el-dialog> -->
    <el-dialog title="订车回访" :visible.sync="returnDialog" width="570px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="returnForm" :inline="true" label-position="right" :model="returnForm" label-width="90px">
        <div class="pure-g">
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="回访结果">
              <el-radio-group v-model="returnForm.contactStatus" size="mini">
                <el-radio-button :label="1">已联系</el-radio-button>
                <el-radio-button :label="2">未联系上</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="是否成交">
              {{ isDeliver ? '已成交' : '未成交' }}
              <div v-if="!isDeliver" style="font-size: 11px;">请耐心等待CRM回传成交信息</div>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="是否生日回访">
              <el-switch v-model="returnForm.birthdayRecall"></el-switch>
            </el-form-item>
          </div>
          <div class="pure-u-1-2" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="下次回访时间">
              <el-date-picker size="mini" style="width:160px;" :picker-options="pickerOptions"
                v-model="returnForm.nextDate" :clearable="false" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </div>
          <div class="pure-u-1-1" style="padding-bottom:12px;">
            <el-form-item class="form_item" label="备注">
              <el-input type="textarea" style="width:330px;" :rows="4" placeholder="请输入备注内容"
                v-model="returnForm.remark"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="doReturn" type="text">确定</el-button>
        <el-button @click="returnDialog = false" type="text">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="通话详情" :visible.sync="asrDialog" width="570px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <div class="records-text">
        <div class="texts">
          <div class="text" v-for="(  item, index  ) in   contentList  " :key="index"
            :class="{ right: item.asrType == '销售' }">
            <div class="t1" v-if="item.asrType == '客户'">
              <img src="../../assets/img/user2.png" alt="" srcset="" />
            </div>
            <div class="t1" v-if="item.asrType == '销售'">
              <img src="../../assets/img/user1.png" alt="" srcset="" />
            </div>
            <div class="t2" v-if="item.asrType == '客户'">
              {{ item.asrText }}
            </div>
            <div class="t2 user" v-if="item.asrType == '销售'">
              {{ item.asrText }}
            </div>
          </div>
        </div>
      </div>
      <audio :src="audioUrl" ref="audio" v-if="audioUrl != ''" preload="auto" controls></audio>
      <span slot="footer" class="dialog-footer">
        <el-button @click="asrDialog = false" type="text">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="客户提醒" :visible.sync="tipDialog" width="400px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <div>
        此手机号{{
          editForm.mobile
        }}已存在于企业微信客户池，创建档案后默认领取该客户，请知晓。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tipDialog = false" type="text">我已知晓</el-button>
      </span>
    </el-dialog>
    <el-dialog title="确认发起客户合并申请" :visible.sync="mergeLog" width="400px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-row justify="space-between" type="flex" style="margin-bottom:10px;color:#303133" v-if="MergeInfo">
        <span>{{ MergeInfo.name }}</span>
        <span>{{ MergeInfo.phone }}</span>
      </el-row>
      <el-row justify="space-between" type="flex" style="margin-bottom:10px" v-if="MergeInfo && MergeInfo.updatedAt">
        <span>跟进时间：{{ MergeInfo.updatedAt | parseTime("{y}/{m}/{d} {h}:{i}") }}</span>
      </el-row>
      <el-row justify="space-between" type="flex" style="margin-bottom:10px" v-if="MergeInfo">
        <span>创建时间：{{ MergeInfo.createdAt | parseTime("{y}/{m}/{d} {h}:{i}") }}</span>
        <span>归属：{{ MergeInfo.ownerName }}</span>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mergeLog = false" type="text">取消</el-button>
        <el-button @click="mergeConfim" type="text" :loading="confirmLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="取消订单" :visible.sync="orderCancelLog2" width="500px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <p>{{ cannotCancelMsg }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderCancelLog2 = false" type="text">我知道了</el-button>
      </span>
    </el-dialog>

    <!-- blc拦截弹窗 -->
    <blc-tips :visible.sync="showBlcTips" :info="blcInfo"></blc-tips>
  </div>
</template>

<script>
import BlcTips from "@/components/blc-tips/index.vue";
import { remarkValidator } from '@/assets/js/util'
import CustomerProfile from './components/CustomerProfile'
import CustomerDynamics from './components/CustomerDynamics'
import CDPTag from './components/CDPTag'
import QwTag from './components/QwTag'
import Upload from "@/components/common/Upload.vue";
import { blindOrderStatusMap, smallOrderStatusMap } from '../order/constants.js'
import dayjs from 'dayjs';

const orderTitleMap = new Map([
  [1, "购车订单"],
  [2, "盲订订单"],
  [3, "小订订单"],
])

var customer_detail_vm;
export default {
  components: { BlcTips, CustomerProfile, CustomerDynamics, CDPTag, Upload, QwTag },
  data() {
    const validateIdentifyNo = (rule, value, callback) => {
      //15位和18位身份证号码的正则表达式
      var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      //如果通过该验证，说明身份证格式正确，但准确性还需计算
      if (regIdCard.test(value)) {
        if (value.length == 18) {
          var idCardWi = new Array(
            7,
            9,
            10,
            5,
            8,
            4,
            2,
            1,
            6,
            3,
            7,
            9,
            10,
            5,
            8,
            4,
            2
          ); //将前17位加权因子保存在数组里
          var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
          var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
          for (var i = 0; i < 17; i++) {
            idCardWiSum += value.substring(i, i + 1) * idCardWi[i];
          }
          var idCardMod = idCardWiSum % 11; //计算出校验码所在数组的位置
          var idCardLast = value.substring(17); //得到最后一位身份证号码
          //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
          if (idCardMod == 2) {
            if (idCardLast == "X" || idCardLast == "x") {
              callback();
            } else {
              callback(new Error("请输入合法证件号"));
            }
          } else {
            //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
            if (idCardLast == idCardY[idCardMod]) {
              callback();
            } else {
              callback(new Error("请输入合法证件号"));
            }
          }
        }
      } else {
        callback(new Error("请输入合法证件号"));
      }
    };
    const validateBuyCarAddress = (rule, value, callback) => {
      const [buyProvince, buyCity] = value
        if (!!buyProvince&&!!buyCity) {
            callback();
        } else {
            callback(new Error("请选择购车地区"));
        }
    }
    customer_detail_vm = this;
    return {
      orderTitleMap,
      blindOrderStatusMap,
      smallOrderStatusMap,
      showBlcTips: false,
      blcInfo: {},
      tipDialog: false,
      SubmitLog: false,
      code: "",
      isSend: true,
      time: 60,
      subLoading: false,
      remark: '',
      testShareDetailDialog: false,
      testShareTimelines: [],
      testShareDetailForm: {},
      // pickerOptions: {
      //   disabledDate(time) {
      //     return time.getTime() < Date.now() - 8.64e7;
      //   },
      // },
      failInfo: {
        reason: "",
        remark: "",
        followTimes: "",
      },
      isSuspend: false,
      cityDealers: [],
      failSubReasonOption: [],
      newFailReasons: [],
      isFail: false,
      DormantDialog: false,
      intendSeriese: "",
      competitionSerie: "",
      dealer: this.$common.getLoginInfo().profile,
      loginInfo: this.$common.getLoginInfo(),
      isAdmin: this.$common.getAdmin(),
      user: this.$common.getUser(),
      dealerProfile: {},
      customerId: parseInt(this.$route.params.customerId),
      customer: {
        onlineSourceName: "",
        tag: "",
      },
      // 虚拟号：与 customer 同级返回，有值才展示
      xPhone: "",
      deal: {},
      testCount: 0,
      timelines: [],
      onlyView: true,
      pendingActivity: {
        createdAt: "",
      },

      levelOptions: [],
      followLevelOptions: [],
      businessTypeOptions: [],
      fromSourceOptions: [],
      failReasons: [],
      contactTypes: [],
      customerTags: [],
      audioIcon:
        '<i class="fa fa-play-circle fa-fw fa-lg" style-"cursor: pointer;" aria-hidden="true"></i>&nbsp;',

      followDialog: false,
      followForm: {
        completedActivityType: 1,
        testResult: 1,
        testSpecId: null,
        level: "N",
        comeDuration: null,
        specIds: [],
        competitionSeries: [],
        nextActivityType: 1,
        nextDate: new Date(),
        nextTestSpecId: null,
        remark: "",
        isSuspend: false,
        failReason: "",
        failReasonDetail: "",
        failSubReason: "",
        failDealerName: "",
        failSeriesId: null,
        resumeDuration: "",
        event: "",
        quote: "",
        reserveComeDate: new Date(),
        home: []
      },
      followFormRules: {
        specIds: [
          {
            required: true,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
        failPurchaseReason: [
          {
            required: true,
            message: "请选择原因",
            trigger: "blur",
          },
        ],
        contactType: [
          {
            required: true,
            message: "请选择沟通方式",
            trigger: "blur",
          },
        ],
        resumeDuration: [
          {
            required: true,
            message: "请选择自动唤醒时间",
            trigger: "blur",
          },
        ],
        comeDuration: [
          {
            required: true,
            message: "请选择到店时长",
            trigger: "blur",
          },
        ],
        failReason: [
          {
            required: true,
            message: "请选择战败原因",
            trigger: "blur",
          },
        ],
        failSubReason: [
          {
            required: true,
            message: "请选择战败次原因",
            trigger: "blur",
          },
        ],
        failReasonDetail: [
          {
            required: true,
            message: "请输入战败原因详情",
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            validator: (...args) => {
              remarkValidator("备注", ...args)
            },
            trigger: "blur",
          },
        ],
        event: [
          {
            required: true,
            message: "请选择发生事件",
            trigger: "blur",
          },
        ],
        testSpecId: [
          {
            required: true,
            message: "请选择试驾车系",
            trigger: "blur",
          },
        ],
        quote: [
          {
            required: true,
            message: "请输入报价金额",
            trigger: "blur",
          },
        ],
        reserveComeDate: [
          {
            required: true,
            message: "请选择预约到店时间",
            trigger: "blur",
          },
        ],
        nextTestSpecId: [
          {
            required: true,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
        notRequired: [
          {
            required: false,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
        home: [
          {
            required: true,
            message: "请选择省市",
            trigger: "blur",
          },
        ],
      },

      carOptions: [],
      seriesOptions: [],
      members: [],
      assignMembers: [],

      remarkDialog: false,
      remarkForm: {
        remark: "",
      },
      remarkFormRules: {
        remark: [
          {
            required: true,
            validator: (...args) => {
              remarkValidator("批注内容", ...args)
            },
            trigger: "blur",
          },
        ],
      },

      assignDialog: false,
      assignForm: {
        memberId: "",
        remark: "",
      },
      assignFormRules: {
        memberId: [
          {
            required: true,
            message: "请选择客户经理",
            trigger: "blur",
          },
        ],
      },

      failDialog: false,
      failForm: {
        failReason: "",
        failSeriesId: "",
        failSubReason: "",
        failDealerName: "",
        failReasonDetail: "",
        remark: "",
      },
      competitionSeries: [],

      reliveDialog: false,
      reliveForm: {
        level: "N",
        memberId: 0,
        specIds: [],
        nextActivityType: 1,
        nextDate: new Date(),
        nextTestSpecId: "",
        remark: "",
      },
      reliveFormRules: {
        memberId: [
          {
            required: true,
            message: "请选择客户经理",
            trigger: "blur",
          },
        ],
        specIds: [
          {
            required: true,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            validator: (...args) => {
              remarkValidator("复活原因", ...args)
            },
            trigger: "blur",
          },
        ],
        nextTestSpecId: [
          {
            required: true,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
        notRequired: [
          {
            required: false,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
      },

      orderDialog: false,
      orderForm: {
        specId: [],
        orderDate: this.$common.addDate(new Date(), 1),
        color: "",
        colors: [],
        price: "",
        payType: 1,
        payInsurance: false,
        remark: "",
      },
      orderFormRules: {
        specId: [
          {
            required: true,
            message: "请选择订购车型",
            trigger: "blur",
          },
        ],
        deliverDate: [
          {
            required: true,
            message: "请选择交车日期",
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入成交价格",
            trigger: "blur",
          },
        ],
        downPayment: [
          {
            required: true,
            message: "请输入购车订金",
            trigger: "blur",
          },
        ],
        color: [
          {
            required: true,
            message: "请选择车辆颜色",
            trigger: "blur",
          },
        ],
      },

      deliverDialog: false,
      deliverForm: {
        specId: 0,
        deliverDate: new Date(),
        color: "",
        colors: [],
        downPayment: 0,
        price: 0,
        payType: 2,
        payInsurance: false,
        remark: "",
        nextRecall: true,
        nextDate: this.$common.addDate(new Date(), 1),
      },
      deliverFormRules: {
        specIds: [
          {
            required: true,
            message: "请选择订购车型",
            trigger: "blur",
          },
        ],
        color: [
          {
            required: true,
            message: "请选择车辆颜色",
            trigger: "blur",
          },
        ],
      },

      recallDialog: false,
      recallForm: {
        contactStatus: 1,
        nextRecall: true,
        nextDate: this.$common.addDate(new Date(), 1),
        remark: "",
        birthdayRecall: false,
      },
      recallFormRules: {},

      rejectFailDialog: false,
      rejectFailForm: {
        memberId: 0,
        specIds: [],
        nextActivityType: 1,
        nextDate: new Date(),
        nextTestSpecId: "",
        remark: "",
        crossRecall: "",
      },
      rejectFailFormRules: {
        memberId: [
          {
            required: true,
            message: "请选择客户经理",
            trigger: "blur",
          },
        ],
        specIds: [
          {
            required: true,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
        nextTestSpecId: [
          {
            required: true,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
        notRequired: [
          {
            required: false,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
        crossRecall: [
          {
            required: false,
            message: "请选择交叉回访",
            trigger: "blur",
          },
        ],
      },

      tagDialog: false,
      tags: [],

      editDialog: false,
      editForm: {
        name: "",
        mobile: "",
        gender: 1,
        type: 1,
        companyName: "",
        fromSource: 1,
        otherSource: "",
        secondardPhone: "",
        fromType: 2,
        onlineSourceName: "",
        businessType: 1,
        buyCount: 0,
        buyCarAddress: [],//购车地区-省市区
        buyProvince: '',// 购车地区-省
        buyCity: '',// 购车地区-市
        buyArea: '',// 购车地区-区
        weixin: "",
        competitionSeries: [],
        budget: "",
        buycarDate: "",
        addition: {
          province: "",
          city: "",
          address: "",
          idNo: "",
          birthday: "",
          qq: "",
        },
        addPurchaseOldSeriesId: ''
      },
      editFormRules: {
        name: [
          {
            required: true,
            message: "请输入客户姓名",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          },
        ],
        buyCarAddress: [
          {
            // type: 'array',
            required: true,
            message: "请选择购车地区",
            trigger: "change",
            validator: validateBuyCarAddress,
          },
        ]
      },

      clueDetailDialog: false,
      clueDetailForm: {
        historySpec: "{}",
        attentionSeries: "{}",
      },
      clueTimelines: [],
      isFromFront: false,

      confirmLoading: false,

      newDialog: false,
      newCustomer: {
        name: "",
        mobile: "",
        weixin: "",
        gender: 1,
        type: 1,
        companyName: "",
        fromSource: 1,
        otherSource: "",
        secondardPhone: "",
        specIds: [],
        competitionSerieses: [],
        budget: 1,
        buyCarAddress: [],//购车地区-省市区
        buyProvince: '',// 购车地区-省
        buyCity: '',// 购车地区-市
        buyArea: '',// 购车地区-区
        businessType: 1,
        level: "N",
        nextActivityType: 1,
        nextDate: new Date(),
        buycarDate: new Date(),
        nextTestSpecId: "",
        remark: "",
        buyCount: "",
        identifyType: 1,
        // idNo: "",
        identifyNo: "",
        identifyNo2: "",
        identifyNo3: "",
        identifyNos: "",
        addition: {
          province: "",
          city: "",
          area: "",
          address: "",
          birthday: "",
          qq: "",
        },
        addPurchaseOldSeriesId: ''
      },
      newCustomerRules: {
        identifyType: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: "blur",
          },
        ],
        identifyNo: [
          {
            required: true,
            validator: validateIdentifyNo,
            trigger: "blur",
          },
        ],
        identifyNo2: [
          {
            required: true,
            // validator: validateIdentifyNo2,
            message: "请输入护照",
            trigger: "blur",
          },
        ],
        identifyNo3: [
          {
            required: true,
            message: "请输入合法军官证件号",
            trigger: "blur",
          },
        ],
        identifyNos: [
          {
            required: true,
            message: "请输入证件号码",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入客户姓名",
            trigger: "blur",
          },
        ],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          },
        ],
        specIds: [
          {
            required: true,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
        nextTestSpecId: [
          {
            required: true,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
        notRequired: [
          {
            required: false,
            message: "请选择意向车型",
            trigger: "blur",
          },
        ],
        buyCarAddress: [
          {
            // type: 'array',
            required: true,
            message: "请选择购车地区",
            trigger: "change",
            validator: validateBuyCarAddress,
          },
        ]
      },
      systemTags: [],
      activityFollowTypes: [],
      activityNextFollowTypes: [],
      activityComeTypes: [],
      customerResumeDurations: [],
      resumeDuration: 7,
      info: {},
      budgetOptions: [],
      value1: false, // 更多
      value2: false, // 更多
      homeOptions: [],
      home: [], //所在地
      props: {
        value: "city",
        label: "city",
        children: "cities",
      },
      additional: {},
      competitionSeriesesOptions: [],
      allowFailVerify: this.$common.getLoginInfo().allowFailVerify,
      allowAssign: false,
      isDeliver: false,
      newMediaUrl: [], // 客户来源凭证
      rejectFailMembers: [],
      customizationList: [],
      orderList: [],
      orderList2: [],
      orderList3: [],
      orderStatusList: [],
      showMoreOrder: false,
      orderCancelForm: {
        reason: "",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      orderCancelRules: {
        reason: [
          {
            required: true,
            validator: (...args) => {
              remarkValidator("取消订单原因", ...args)
            },
            trigger: "blur",
          },
        ],
      },
      orderCancelLog: false,
      orderCancelLog2: false,
      allowCancel2: false, //是否允许关闭订单
      cannotCancelMsg: '',
      needCheckOrder: false, // 是否需要核销码
      returnDialog: false,
      returnForm: {
        contactStatus: 1,
        // isDeliver: false,
        nextDate: new Date(),
        remark: "",
        birthdayRecall: false,
      },
      showMoreOrder2: false,
      showMoreOrder3: false,
      contentList: [],
      audioUrl: "",
      asrDialog: false,
      wechatSummaryDialog: false, // 企微智能总结弹框
      wechatSummaryContent: "", // 企微智能总结内容（纯文本）
      smartCallDetailDialog: false, // 智慧号通话详情弹框
      smartCallDetailContent: "", // 智慧号通话详情内容（纯文本）
      // 通话记录编辑相关
      callEditDialog: false, // 通话编辑弹框
      callEditForm: {
        id: null,
        content: "",
        durationPrefix: "", // "通话时长X秒\n"前缀，保存时拼回content
      },
      callEditLoading: false, // 通话编辑保存加载状态
      provinces: [],// 省份
      citys: [],// 省/市/区 - 城市列表
      countys: [],// 省/市/区   --区域列表
      buyCarCityList: [],// 购车地区-城市列表
      buyCarAreaList: [],// 购车地区-城市列表
      orderIdentifyTypeDics: [], // 证件类型
      purchaseOldSeries: {},
      failProductReasonDics: [],
      isNoPhone: false,//是否无手机号建档客户
      mergeLog: false,
      MergeInfo: {},
      failCities: [],//战败省份/城市
      reBuyCarCityList: [],// 再次购车-购车地区-城市列表
      reBuyCarAreaList: [],// 再次购车-购车地区-城市列表
      dealerProvince: '',// 门店所在省份
      dealerCity: '',// 门店所在市
      dealerArea: '',// 门店所在区
      baseInfo: {},
      activeName: 'FollowRecords',
      // 垂媒画像：外部系统 H5 链接（客户 xPhone 不为空时，调用 appCustomerService/autohomeSmartUrl 获取）
      mediaProfileUrl: '',
      mediaProfileLoading: false, // H5 加载中状态
      cdpProfile: [], // CDP客户画像
      cdpTag: [], // CDP标签
      customerOrder: {}, // 订单详情
      isUpdate: false // 订单是否被修改
    };
  },
  filters: {
    levelDisplay(level) {
      for (var i = 0; i < customer_detail_vm.levelOptions.length; i++) {
        var o = customer_detail_vm.levelOptions[i];
        if (o.dataName == level) {
          return o.dataDisplay;
        }
      }
      return "";
    },
    businessTypeDisplay(type) {
      for (var i = 0; i < customer_detail_vm.businessTypeOptions.length; i++) {
        var o = customer_detail_vm.businessTypeOptions[i];
        if (o.dataValue == type) {
          return o.dataDisplay;
        }
      }
      return "";
    },
    // fromSourceDisplay(type) {
    //   for (var i = 0; i < customer_detail_vm.newFromSourceOptions.length; i++) {
    //     var o = customer_detail_vm.newFromSourceOptions[i];
    //     if (o.dataValue == type) {
    //       return o.dataDisplay;
    //     }
    //   }
    //   return "";
    // },
    activityTypeDisplay(type) {
      const displayMap = {
        1: "电话",
        2: "邀约到店",
        3: "邀约试驾",
        4: "订车回访",
        5: "交车",
        8: "回访",
      };
      return displayMap[type + ""];
    },
    budgetDisplay(val) {
      let str = "";
      if (val) {
        customer_detail_vm.budgetOptions.forEach((item) => {
          if (val == item.dataValue) {
            str = item.dataDisplay;
          }
        });
      }
      return str;
    },
  },
  created() {
    this.baseInfo = this.$common.getBaseInfo();
    var loginInfo = this.$common.getLoginInfo();
    this.followLevelOptions = this.baseInfo.customerFollowLevels;
    this.levelOptions = this.baseInfo.customerLevels;
    this.businessTypeOptions = this.baseInfo.businessTypes;
    this.orderStatusList = this.baseInfo.orderStatusDics;
    this.fromSourceOptions = this.baseInfo.customerFromSources;
    this.contactTypes = this.baseInfo.contactTypes || [];
    this.failReasons = this.baseInfo.failReasons;
    this.customerTags = this.baseInfo.customerTags;
    this.budgetOptions = this.baseInfo.budgets;
    this.budgetOptions.forEach((item) => {
      item.dataDisplay = item.dataDisplay + "万元";
    });
    this.activityFollowTypes = this.baseInfo.activityFollowTypes;
    this.activityNextFollowTypes = this.baseInfo.activityNextFollowTypes;
    this.activityComeTypes = this.baseInfo.activityComeTypes;
    this.customerResumeDurations = this.baseInfo.customerResumeDurations;
    if (loginInfo.cityPoolEnable) {
      this.newFailReasons = this.baseInfo.newFailReasons
    } else {
      this.newFailReasons = this.baseInfo.newFailReasons.filter(item => item.dataValue != 15);
    }
    this.homeOptions = this.baseInfo.cities;
    this.homeOptions.forEach((item) => {
      item.city = item.province;
    });
    this.orderIdentifyTypeDics = this.baseInfo.orderIdentifyTypeDics;
    this.failProductReasonDics = this.baseInfo.failProductReasonDics;
    this.failCities = this.getProvinceOptions(this.baseInfo.failCities);
    this.retrieveProfile();
    this.retrieveCarOptions();
    this.retrieveMembers();
    this.retrieveRejectFailMembers();
    this.retrieveSeriesOptions();
    this.getProvinces();
    this.getCompetitionSeriesesOptions();
  },
  mounted() {
    this.retrieveSeriesOptions();
    this.getcustomizationList();
  },
  methods: {
    handleOrderSubmit(order) {
      if(!order.orderType) {
        this.$message({ type: "error", message: "请选择订单类型" });
        return;
      }
      this.SubmitLog = true;
      this.reset()
    },
    formatLabel(val, list) {
      return list.find(item => item.dataValue === val)?.dataDisplay ?? ''
    },
    fromSourceDisplay(type) {
      // for (let i = 0; i < this.newFromSourceOptions.length; i++) {
      //   let o = this.newFromSourceOptions[i];
      //   if (o.dataValue == type) {
      //     return o.dataDisplay;
      //   }
      // }
      // return "";
      return this.newFromSourceOptions.find(item => item.dataValue === type)?.dataDisplay ?? ''
    },
    getProvinceOptions(data) {
      let result = [];
      let provinces = {};
      for (let i = 0; i < data.length; i++) {
        let city = data[i];
        if (!provinces[city.province]) {
          let province = { label: city.province };
          result.push(province);
          provinces[city.province] = [];
        }
        provinces[city.province].push({ label: city.city });
      }
      for (let i = 0; i < result.length; i++) {
        let province = result[i];
        province.children = provinces[province.label];
      }
      return result;
    },
    identifyTypeChange() {
      this.editForm.identifyNo = "";
      this.editForm.identifyNo2 = "";
      this.editForm.identifyNo3 = "";
      this.editForm.identifyNos = "";
    },
    // 省改变
    provinceChange(provinceName) {
      this.getCityList(provinceName).then(res => {
        this.citys = res.data.data;
        this.editForm.addition.city = "";
        this.editForm.addition.area = "";
      })
    },
    // 市改变
    cityChange(cityName) {
      const params = {
        dealerId: this.dealer.dealerId,
        province: this.editForm.addition.province,
        city:cityName
      }
      this.getAreaList(params).then(res => {
        this.countys = res.data.data;
        this.editForm.addition.area = "";
      })
    },
    // 获取区
    getAreaList(params) {
      return new Promise((resolve,reject) => {
        this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", params)
        .then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取市
    getCityList(provinceName) {
      return new Promise((resolve,reject)=> {
        this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: provinceName,
          city: "",
        })
        .then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取省
    getProvinces() {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: "",
          city: "",
        })
        .then((res) => {
          this.provinces = res.data.data;
          this.dealerProvince = res.data.province;
          this.dealerCity = res.data.city;
          this.dealerArea = res.data.county;
        });
    },
    // 改变购车地区省
    changeBuyCarProvince(provinceName) {
      this.editForm.buyCity = "";
      this.editForm.buyArea = "";
      this.buyCarCityList = [] // 清除市列表
      this.buyCarAreaList = [] // 清除区列表
      if (provinceName) {
        this.getCityList(provinceName).then(res => {
          this.buyCarCityList = res.data.data;
        })
        this.editForm.buyCarAddress = [provinceName]// 重置选择项
        
      } else {
        this.editForm.buyProvince = "";
        this.editForm.buyCarAddress = []// 重置选择项
      }
    },
    // 改变购车城市
    changeBuyCarCity(cityName) {
      const params = {
        dealerId: this.dealer.dealerId,
        province: this.editForm.buyProvince,
        city:cityName
      }
      this.editForm.buyArea = "";// 清除区
      this.buyCarAreaList = []// 清除区列表
      // 选择区域
      if (cityName) {
        // 获取区域
        this.getAreaList(params).then(res => {
          this.buyCarAreaList = res.data.data;
        })
        this.editForm.buyCarAddress = [this.editForm.buyCarAddress[0],cityName]// 重置选择项
      } else {
        // 清空市
        this.editForm.buyCity = "";// 清除市
        this.editForm.buyCarAddress = [this.editForm.buyCarAddress[0]]// 重置选择项
      }
    },
    // 改变购车地区区域
    changeBuyCarArea(areaName) {
      if (areaName) {
        this.editForm.buyCarAddress =[this.editForm.buyCarAddress[0], this.editForm.buyCarAddress[1], areaName]// 更新选择项
      } else {
        this.editForm.buyArea = "";
        this.editForm.buyCarAddress =[this.editForm.buyCarAddress[0], this.editForm.buyCarAddress[1]]// 重置选择项
      }
      this.$forceUpdate()
    },
    // 改变再次购车-购车地区省份
    changeReBuyCarProvince(provinceName) {
      this.newCustomer.buyCity = "";
      this.newCustomer.buyArea = "";
      this.reBuyCarCityList = [] // 清除市列表
      this.reBuyCarAreaList = [] // 清除区列表
      if (provinceName) {
        this.getCityList(provinceName).then(res => {
          this.reBuyCarCityList = res.data.data;
        })
        this.newCustomer.buyCarAddress = [provinceName]// 重置选择项
        
      } else {
        this.newCustomer.buyProvince = "";
        this.newCustomer.buyCarAddress = []// 重置选择项
      }
    },
    // 改变再次购车-购车城市
    changeReBuyCarCity(cityName) {
      const params = {
        dealerId: this.dealer.dealerId,
        province: this.newCustomer.buyProvince,
        city:cityName
      }
      this.newCustomer.buyArea = "";// 清除区
      this.reBuyCarAreaList = []// 清除区列表
      // 选择区域
      if (cityName) {
        // 获取区域
        this.getAreaList(params).then(res => {
          this.reBuyCarAreaList = res.data.data;
        })
        this.newCustomer.buyCarAddress = [this.newCustomer.buyCarAddress[0],cityName]// 重置选择项
      } else {
        // 清空市
        this.newCustomer.buyCity = "";// 清除市
        this.newCustomer.buyCarAddress = [this.newCustomer.buyCarAddress[0]]// 重置选择项
      }
    },
    // 改变再次购车-购车地区区域
    changeReBuyCarArea(areaName) {
      if (areaName) {
        this.newCustomer.buyCarAddress =[this.newCustomer.buyCarAddress[0], this.newCustomer.buyCarAddress[1], areaName]// 更新选择项
      } else {
        this.newCustomer.buyArea = "";
        this.newCustomer.buyCarAddress =[this.newCustomer.buyCarAddress[0], this.newCustomer.buyCarAddress[1]]// 重置选择项
      }
      this.$forceUpdate()
    },
    // 获取客户订单列表
    getOrder() {
      this.$httpAuth
        .post("/v2/appCustomerService/customerOrders", {
          dealerId: this.dealer.dealerId,
          customerId: this.customerId,
          dealId: this.info.dealId,
          pageStart: 0,
          pageCount: 100,
        })
        .then((res) => {
          // data智蛛订单  data2未转大订盲订订单
          const { data = [], data2 = [], data3 = [] } = res.data || {}
          this.orderList = [].concat(data.map(item=> { item.zzType = 1; return item } ), data2.map(item=> { item.zzType = 2; return item } ), data3.map(item=> { item.zzType = 3; item.createdAt = dayjs(item.createdTime).unix();  return item } )).sort((a, b) => b.createdAt - a.createdAt);
          // 获取待订单详情
          if(this.orderList[0] && this.orderList[0].zzType === 1) {
            this.getOrderDetail(this.orderList[0])
          }
          // 待提交订单
          this.orderList2 = data.filter(
            (item) => item.status === 1 || item.status === 6
          );
          // 未处理订单
          this.orderList3 = data.filter(
            (item) =>
              item.status === 1 || item.status === 2 || item.status === 6
          );
        });
    },
    // 获取订单详情
    getOrderDetail(item) {
      this.$httpAuth
        .post("/v2/appCustomerService/orderDetail", {
          orderId: item.id,
          dealerId: this.dealer.dealerId,
        })
        .then((res) => {
          const { data = {} } = res;
          this.allowCancel2 = data.allowCancel2;
          this.cannotCancelMsg = data.cannotCancelMsg;
          this.needCheckOrder = data.needCheckOrder;
          this.remark = data.remark
          this.customerOrder = data.order
          this.isUpdate = data.isUpdate
        });
    },
    // 取消订单
    orderCancel() {
      if (this.allowCancel2) {
        this.orderCancelForm = {
          reason: "",
        };
        this.orderCancelLog = true;
      } else {
        this.orderCancelLog2 = true;
      }
    },
    reset() {
      this.code = "";
      this.isSend = true;
      this.time = 60;
    },
    sendSms() {
      if (this.isSend) {
        this.getCode();
      }
      this.isSend = false;
      this.phoneTimer();
    },
    // 手机倒计时
    phoneTimer() {
      if (this.time > 0) {
        this.time--;
        setTimeout(() => {
          this.phoneTimer();
        }, 1000);
      } else {
        this.isSend = true;
        this.time = 60;
      }
    },
    //获取核销码
    getCode() {
      if (this.orderList[0].extOrderId === "") {
        this.$message({ type: "warning", message: "无需获取核销码" });
        return;
      }
      this.$httpAuth
        .post("/v2/appCustomerService/orderSendSms", {
          dealerId: this.dealer.dealerId,
          orderId: this.orderList[0].id,
        })
        .then(() => { })
        .catch(() => { });
    },
    // 提交审批
    Submit() {
      if (!this.needCheckOrder && this.orderList[0].images1.length === 0) {
        this.$message({ type: "error", message: "请上传订车合同/协议" });
        return;
      }
      this.subLoading = true;
      var that = this;
      // 1、若订单未锁单，无论订单是否存在修改，则都需要核销；

      // 2、若订单从C端同步过来后，订单存在修改更新，无论订单是否锁单，则需要核销。
      if (this.orderList[0].extOrderId != "" && (!this.customerOrder.isLocked || this.isUpdate)) {
        this.$httpAuth
          .post("/v2/appCustomerService/orderCheckSms", {
            dealerId: this.dealer.dealerId,
            orderId: this.orderList[0].id,
            code: this.code,
          })
          .then((res) => {
            if (res.data.success) {
              this.$httpAuth
                .post("/v2/appCustomerService/submitOrder", {
                  dealerId: this.dealer.dealerId,
                  orderId: this.orderList[0].id,
                })
                .then(function (res) {
                  that.subLoading = false;
                  if (res.data.orderId) {
                    that.SubmitLog = false;
                    if (res.data.is_auto_create === 1) {
                      that.$message({ type: "success", message: "提交订单成功，到店登记已自动生成" });
                    } else {
                      that.$message({ type: "success", message: "提交订单成功" });
                    }
                    that.getOrder()
                    // that.$router.push({
                    //   path: "/customer/detail/" + that.form.customerId,
                    // });
                  }
                })
                .catch(() => {
                  that.subLoading = false;
                  that.SubmitLog = false;
                });
            }
          })
          .catch(() => {
            that.subLoading = false;
          });
      } else {
        this.$httpAuth
          .post("/v2/appCustomerService/submitOrder", {
            dealerId: this.dealer.dealerId,
            orderId: this.orderList[0].id,
          })
          .then(function (res) {
            that.subLoading = false;
            if (res.data.orderId) {
              that.SubmitLog = false;
              that.$message({ type: "success", message: "提交订单成功" });
              that.getOrder()
            }
          })
          .catch(() => {
            that.subLoading = false;
            that.SubmitLog = false;
          });
      }
    },
    // 提交订单
    // orderSubmit() {
    //   var that = this;
    //   this.$httpAuth
    //     .post("/v2/appCustomerService/submitOrder", {
    //       dealerId: this.dealer.dealerId,
    //       orderId: this.orderList[0].id,
    //     })
    //     .then(function (res) {
    //       if (res.data.orderId) {
    //         that.SubmitLog = false;
    //         that.$message({ type: "success", message: "提交订单成功" });
    //         that.getOrder();
    //       }
    //     })
    //     .catch(() => {
    //       that.SubmitLog = false;
    //     });
    // },
    // 订单撤回
    orderWithdraw() {
      this.$confirm("是否确定撤回该订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var that = this;
          this.$httpAuth
            .post("/v2/appCustomerService/cancelOrder", {
              dealerId: this.dealer.dealerId,
              orderId: this.orderList[0].id,
              reason: "1",
            })
            .then(function () {
              that.$message({
                type: "success",
                message: "撤回订单成功",
              });
              that.getOrder();
            })
            .catch(() => { });
        })
        .catch(() => { });
    },
    // 取消订单确定
    orderCanceConfim() {
      this.$refs["orderCancelForm"].validate((valid) => {
        if (valid) {
          var parent = this;
          parent.confirmLoading = true;
          this.$httpAuth
            .post("/v2/appCustomerService/cancelOrder", {
              dealerId: this.dealer.dealerId,
              orderId: this.orderList[0].id,
              reason: this.orderCancelForm.reason,
            })
            .then(function () {
              parent.$message({
                type: "success",
                message: "取消订单成功",
              });
              parent.confirmLoading = false;
              parent.orderCancelLog = false;
              parent.getOrder();
            })
            .catch(() => {
              parent.confirmLoading = false;
            });
        }
      });
    },
    // 订单详情
    // orderDetail() {
    //   sessionStorage.setItem("form", "customerDetail");
    //   switch (this.orderList[0].status) {
    //     case 1: // 待提交
    //       this.$router.push({
    //         path: "/waitingSubmit",
    //         query: { id: this.orderList[0].id },
    //       });
    //       break;
    //     case 2: // 已提交
    //       if (sessionStorage.getItem("type") === "1") {
    //         this.$router.push({
    //           path: "/submitted",
    //           query: { id: this.orderList[0].id, type: 1 },
    //         });
    //       } else {
    //         this.$router.push({
    //           path: "/submitted",
    //           query: { id: this.orderList[0].id },
    //         });
    //       }

    //       break;
    //     case 3: // 待配车
    //       this.$router.push({
    //         path: "/approved",
    //         query: { id: this.orderList[0].id },
    //       });
    //       break;
    //     case 4: // 已配车
    //       this.$router.push({
    //         path: "/isCar",
    //         query: { id: this.orderList[0].id },
    //       });
    //       break;
    //     case 6: // 订单已驳回
    //       this.$router.push({
    //         path: "/rejected",
    //         query: { id: this.orderList[0].id },
    //       });
    //       break;
    //     case 8: // 已取消
    //       this.$router.push({
    //         path: "/orderCancel",
    //         query: { id: this.orderList[0].id },
    //       });
    //       break;
    //     case 10: // 已交车
    //       this.$router.push({
    //         path: "/isCar",
    //         query: { id: this.orderList[0].id },
    //       });
    //       break;
    //     case 12: // 授权配车
    //       this.$router.push({
    //         path: "/approved",
    //         query: { id: this.orderList[0].id },
    //       });
    //       break;
    //     case 13: // 已退订
    //       this.$router.push({
    //         path: "/backOrder",
    //         query: { id: this.orderList[0].id },
    //       });
    //       break;
    //     default:
    //       break;
    //   }
    // },
    // 更多订单详情
    toOrderDetail(item) {
      sessionStorage.setItem("form", "customerDetail");
      // 小订订单
      if(item.zzType === 3) {
        this.$router.push({
          path: "/order/smallOrderDetail",
          query: { smallOrderId: item.id },
        });
        return
      }
      // 盲订订单
      if(item.zzType === 2) {
        this.$router.push({
          path: "/order/blindOrderDetail",
          query: { blingOrderId: item.id },
        });
        return
      }
      // 智蛛订单
      switch (item.status) {
        case 1: // 待提交
          this.$router.push({
            path: "/waitingSubmit",
            query: { id: item.id },
          });
          break;
        case 2: // 已提交
          if (sessionStorage.getItem("type") === "1") {
            this.$router.push({
              path: "/submitted",
              query: { id: item.id, type: 1 },
            });
          } else {
            this.$router.push({
              path: "/submitted",
              query: { id: item.id },
            });
          }
          break;
        case 3: // 待配车
          this.$router.push({
            path: "/approved",
            query: { id: item.id },
          });
          break;
        case 4: // 已配车
          this.$router.push({
            path: "/isCar",
            query: { id: item.id },
          });
          break;
        case 6: // 订单已驳回
          this.$router.push({
            path: "/rejected",
            query: { id: item.id },
          });
          break;
        case 8: // 已取消
          this.$router.push({
            path: "/orderCancel",
            query: { id: item.id },
          });
          break;
        case 10: // 已交车
          this.$router.push({
            path: "/isCar",
            query: { id: item.id },
          });
          break;
        case 12: // 授权配车
          this.$router.push({
            path: "/approved",
            query: { id: item.id },
          });
          break;
        case 13: // 已退订
          this.$router.push({
            path: "/backOrder",
            query: { id: item.id },
          });
          break;
        case 16: // 退款申请审核中
          this.$router.push({
            path: "/refundUnderReview",
            query: { id: item.id },
          });
          break;
        case 18: // 待退款
          this.$router.push({
            path: "/pendingRefund",
            query: { id: item.id },
          });
          break;
        default:
          break;
      }
    },
    toOrder3() {
      this.toOrderDetail(this.orderList2[0]);
    },
    toOrder4() {
      this.toOrderDetail(this.orderList3[0]);
    },
    // 订车回访
    showReturnDialog() {
      if (this.deal.level == "O") {
        this.returnForm = {
          contactStatus: 1,
          // isDeliver: false,
          nextDate: new Date(),
          remark: "",
          birthdayRecall: false,
        };
        this.returnDialog = true;
        return;
      }
      if (this.deal.level == "D") {
        this.showRecallDialog();
        return;
      }
    },
    // 订车回访确定
    doReturn() {
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/orderFollow", {
          dealerId: this.dealer.dealerId,
          customerId: this.customerId,
          dealId: this.info.dealId,
          contactStatus: this.returnForm.contactStatus,
          isDeliver: this.isDeliver,
          nextDate: parseInt(this.returnForm.nextDate.getTime() / 1000),
          remark: this.returnForm.remark,
          birthdayRecall: this.returnForm.birthdayRecall,
        })
        .then((res) => {
          if (res.data.success) {
            that.returnDialog = false;
            that.$message({
              type: "success",
              message: "订车回访成功",
            });
            that.retrieveProfile();
          }
        })
        .catch(() => {
          that.returnDialog = false;
        });
    },
    //交叉回访选择
    changeCross(val) {
      if (!val) {
        this.rejectFailForm.memberId = this.deal.ownerId;
      } else {
        let arr = [];
        this.rejectFailMembers.forEach((item) => {
          if (item.role == 4 && item.memberId != this.deal.ownerId) {
            arr.push(item);
          }
        });
        if (arr.length == 0) {
          this.rejectFailForm.memberId = "";
        } else {
          this.rejectFailForm.memberId =
            arr[Math.round(Math.random() * (arr.length - 1))].memberId;
        }
      }
    },
    // 驳回战败选择客户经理
    changeMember(val) {
      if (val == this.deal.ownerId) {
        this.rejectFailForm.crossRecall = false;
      } else {
        this.rejectFailForm.crossRecall = true;
      }
    },
    // 其他来源数据
    getcustomizationList() {
      this.$httpAuth
        .post("/v2/appDealerManagerService/sourceList", {
          dealerId: this.dealer.dealerId,
        })
        .then((res) => {
          this.customizationList = res.data.data;
        });
    },
    retrieveRejectFailMembers() {
      this.rejectFailMembers = [];
      var parent = this;
      this.$httpAuth
        .post("/v2/appDealerManagerService/memberList", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.rejectFailMembers = response.data.data;
          // var arr = response.data.data;
          // for (var i = 0; i < arr.length; i++) {
          //   if (arr[i].memberId != parent.deal.ownerId) {
          //     parent.rejectFailMembers.push(arr[i]);
          //   }else {
          //     // console.log(arr[i]);
          //   }
          // }
          // for(var i = 0; i < arr.length;i++){
          //    if(arr[i])
          // }
          // parent.rejectFailMembers = response.data.data;
          // response.data.data.forEach(item => {
          //     if(item)
          // });
        });
    },
    retrieveMembers() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerMemberRpc/managerMembers", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.members = response.data.data;
        });
    },
    getCityDealers() {
      var parent = this;
      this.$httpAuth
        .post("/v2/appCustomerService/cityDealers", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.cityDealers = response.data.data;
        });
    },
    retrieveSeriesOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/seriesList", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.seriesOptions = response.data.records;
        });
    },
    retrieveCarOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/vehicleJsonTree", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.carOptions = response.data.data;
        });
    },
    retrieveProfile() {
      var parent = this;
      parent.intendSeriese = "";
      parent.competitionSerie = "";
      this.$httpAuth
        .post("/v2/appCustomerService/get", {
          dealerId: this.dealer.dealerId,
          customerId: this.customerId,
        })
        .then(function (response) {
          const { cdpTag = "", cdpProfile = "", newMediaUrl = [] } = response.data
          parent.allowAssign = response.data.allowAssign;
          parent.isSuspend = response.data.isSuspend;
          parent.failInfo = JSON.parse(JSON.stringify(response.data.failInfo));
          parent.failInfo.reason = parent.failInfo.reason.split(" ").join(",");
          parent.customer = response.data.customer;
          // 虚拟号与 customer 同级返回，无值时兜底为空串（模板 v-if 判空）
          parent.xPhone = response.data.xPhone || "";
          parent.additional = response.data.additional;
          parent.isDeliver = response.data.isDeliver;
          parent.newMediaUrl = newMediaUrl ? newMediaUrl.map(n=>n.image) : []
          
          parent.cdpProfile = cdpProfile !== "" ? JSON.parse(cdpProfile) : [];
          parent.cdpTag = cdpTag !== "" ? JSON.parse(cdpTag) : [];
          // 初次获取省市区列表
          const {buyProvince,buyCity } = parent.additional
          if (buyProvince) {
            parent.getCityList(buyProvince).then(e => {
              parent.buyCarCityList = e.data.data
            })
          }
          if (buyCity) {
            parent.getAreaList({ dealerId: parent.dealer.dealerId,province: buyProvince,city:buyCity }).then(e => {
              parent.buyCarAreaList = e.data.data;
            })
          }
          parent.systemTags = response.data.info.systemTags.split(" ");
          parent.tags = parent.customer.tag != '' ?parent.customer.tag.split(" ") :[];
          parent.deal = response.data.customer.deal;
          parent.info = response.data.info;
          // xPhone 不为空时查询垂媒画像外部 H5 链接（dealId 取 info.dealId，与项目其他接口口径一致）
          if (parent.xPhone) {
            parent.retrieveMediaProfileUrl();
          }
          if (parent.info && parent.info.sourceName) {
            const sourceNameArr = parent.info.sourceName.split('渠道:')
            if (sourceNameArr[1]) {
              parent.info.sourceName = sourceNameArr[1]
            }
          }
          if (parent.info && parent.info.reactivateSource) {
            const reactivateSourceArr = parent.info.reactivateSource.split('渠道:')
            if (reactivateSourceArr[1]) {
              parent.info.reactivateSource = reactivateSourceArr[1]
            }
          }
          parent.info.intendSerieses.forEach((item) => {
            parent.intendSeriese += "," + item.name;
          });
          if (parent.info.intendSerieses.length > 0) {
            parent.intendSeriese = parent.intendSeriese.substr(1);
          }
          parent.purchaseOldSeries = response.data.purchaseOldSeries;
          // parent.info.competitionSeries.forEach(item => {
          //   parent.seriesOptions.forEach(b => {
          //     if (item.id == b.specId) {
          //       item.name = b.name;
          //     }
          //   });
          // });
          parent.info.competitionSeries.forEach((item) => {
            parent.competitionSerie += "," + item.name;
          });
          if (parent.info.competitionSeries.length > 0) {
            parent.competitionSerie = parent.competitionSerie.substr(1);
          }
          parent.pendingActivity = response.data.pendingActivity;
          parent.timelines = response.data.timelines || [];
          parent.onlyView = response.data.onlyView;
          if (parent.$route.query.a == 1) {
            parent.onlyView = true;
            parent.isFromFront = true;
          }
          parent.getOrder();
          if (parent.deal.specId > 0) {
            parent.$httpAuth
              .post("/v1/baseRpc/getSpec", {
                id: parent.deal.specId,
              })
              .then(function (response) {
                parent.deal.specName = response.data.spec.seriesName;
              })
              .catch(() => { });
          }
        })
        .catch((e) => { console.log(e, '初始化用户数据失败') });
    },
    // 刷新智慧号：仅重取 xPhone，复用 retrieveProfile 同一接口口径，不整页刷新其他数据
    refreshXPhone() {
      var parent = this;
      parent.xPhoneLoading = true;
      this.$httpAuth
        .post("/v2/appCustomerService/get", {
          dealerId: this.dealer.dealerId,
          customerId: this.customerId,
        })
        .then(function (response) {
          parent.xPhone = response.data.xPhone || "";
          parent.xPhoneLoading = false;
        })
        .catch(function (e) {
          console.log(e, "刷新智慧号失败");
          parent.xPhoneLoading = false;
        });
    },
    // 查询垂媒画像（汽车之家用户画像）外部 H5 链接
    // 入参：dealerId 经销商ID / customerId 客户ID / dealId 交易ID
    // 出参：成功时将 URL 写入 mediaProfileUrl（驱动 tab 与 iframe 展示）；任何失败均置空，不阻断主流程
    retrieveMediaProfileUrl() {
      var parent = this;
      parent.mediaProfileLoading = true;
      // 走内部网关相对路径（复用 $httpAuth 的 baseURL 与 Authorization 登录态）
      this.$httpAuth
        .post("/v2/appCustomerService/autohomeSmartUrl", {
          dealerId: this.dealer.dealerId,
          customerId: this.customerId,
          dealId: this.info.dealId,
        })
        .then(function (response) {
          // 边界1：兼容 data.data 与 data.url 两种返回结构；均为空时兜底为空串，tab 隐藏
          const url = (response.data && (response.data.data || response.data.url)) || "";
          parent.mediaProfileUrl = url;
          // 边界2：未取到链接时结束 loading，避免 iframe 区域常驻遮罩
          parent.mediaProfileLoading = false;
        })
        .catch((e) => {
          // 边界3：接口异常/超时，静默置空并结束 loading，不影响客档详情主数据渲染
          console.log(e, "查询垂媒画像链接失败");
          parent.mediaProfileUrl = "";
          parent.mediaProfileLoading = false;
        });
    },
    playAudio(url) {
      window.open(url, "_blank");
    },
    changeActivityLevel() {
      var days = 0;
      for (var i = 0; i < this.followLevelOptions.length; i++) {
        var o = this.followLevelOptions[i];
        if (o.dataName == this.followForm.level) {
          days = o.dataValue;
          break;
        }
      }
      this.followForm.nextDate = this.$common.addDate(new Date(), days);
      switch (this.followForm.level) {
        case "N":
          this.pickerOptions = {
            disabledDate(time) {
              return (
                Date.now() - 3600 * 24 * 1000 > time.getTime() ||
                time.getTime() > new Date().getTime() + 3600 * 24 * 2 * 1000
              );
            },
          };
          break;
        case "H":
          this.pickerOptions = {
            disabledDate(time) {
              return (
                Date.now() - 3600 * 24 * 1000 > time.getTime() ||
                time.getTime() > new Date().getTime() + 3600 * 24 * 6 * 1000
              );
            },
          };
          break;
        case "A":
          this.pickerOptions = {
            disabledDate(time) {
              return (
                Date.now() - 3600 * 24 * 1000 > time.getTime() ||
                time.getTime() > new Date().getTime() + 3600 * 24 * 14 * 1000
              );
            },
          };
          break;
        case "B":
          this.pickerOptions = {
            disabledDate(time) {
              return (
                Date.now() - 3600 * 24 * 1000 > time.getTime() ||
                time.getTime() > new Date().getTime() + 3600 * 24 * 30 * 1000
              );
            },
          };
          break;
        case "C":
          this.pickerOptions = {
            disabledDate(time) {
              return (
                Date.now() - 3600 * 24 * 1000 > time.getTime() ||
                time.getTime() > new Date().getTime() + 3600 * 24 * 90 * 1000
              );
            },
          };
          break;
        default:
          break;
      }
    },
    showFollowDialog() {
      if (this.deal.level == "D") {
        this.showRecallDialog();
        return;
      }
      if (this.deal.level == "O") {
        this.showReturnDialog();
        return;
      }
      var parent = this;

      this.confirmLoading = false;

      var specIds = [];
      var competitionSeries = [];
      this.info.intendSerieses.forEach((item) => {
        specIds.push(item.id);
      });
      this.info.competitionSeries.forEach((item) => {
        competitionSeries.push(item.id);
      });
      var testSpecId = this.pendingActivity.testSpecName;

      this.followForm = {
        completedActivityType: this.pendingActivity.type,
        contactType: "",
        testResult: 1,
        testSpecId: testSpecId,
        competitionSeries: competitionSeries,
        level: this.pendingActivity.level,
        specIds: specIds,
        nextActivityType: 1,
        nextDate: new Date(),
        nextTestSpecId: "",
        remark: "",
        isSuspend: false,
        failReason: "",
        failSubReason: "",
        failReasonDetail: "",
        failDealerName: "",
        failSeriesId: "",
        resumeDuration: "",
        event: "",
        quote: "",
        reserveComeDate: new Date(),
        home: []
      };
      this.isFail = false;
      if (this.pendingActivity.contactType) {
        this.followForm = this.pendingActivity.contactType;
      }

      this.changeActivityLevel();
      this.followDialog = true;
      this.getCityDealers();
      this.$httpAuth
        .post("/v1/dealerRpc/getCompetitionSeriesList", {
          dealerId: this.dealer.dealerId,
          key: "",
        })
        .then((response) => {
          this.competitionSeries = response.data.data;
          for (const ele of this.info.competitionSeries) {
            if(this.competitionSeries.every(n=>n.id !== ele.id)) {
              this.competitionSeries.push({
                ...ele,
                seriesName: ele.name,
                brandName: '',
                disabled: true
              })
            }
          }
          
        });
      // if (this.$refs["followForm"]) {
      //   this.$refs["followForm"].resetFields();
      // }
    },
    eventChange(val) {
      if (val != 4 && val != 5) {
        this.followForm.nextActivityType = val;
      } else {
        this.followForm.nextActivityType = 1
      }
    },
    dohandlePending() {
      this.$refs["followForm"].validate((valid) => {
        if (valid) {
          if (typeof this.followForm.testSpecId == "string") {
            this.followForm.testSpecId = this.pendingActivity.testSpecId;
          }
          if (typeof this.followForm.nextTestSpecId == "string") {
            this.followForm.nextTestSpecId = this.pendingActivity.nextTestSpecId;
          }
          if (this.isFail && this.followForm.failReason == "") {
            this.$message({
              type: "error",
              message: "请选择战败原因",
            });
            return;
          }
          if (
            this.followForm.isSuspend &&
            this.followForm.resumeDuration == ""
          ) {
            this.$message({
              type: "error",
              message: "请选择自动唤醒时间",
            });
            return;
          }
          if (
            (this.isFail || this.followForm.isSuspend) &&
            this.orderList3.length > 0
          ) {
            this.showMoreOrder3 = true;
            return;
          }
          this.confirmLoading = true;
          var parent = this;
          let params = {
            dealerId: this.dealer.dealerId,
            customerId: this.customerId,
            dealId: this.deal.id,
            activityId: this.pendingActivity.id,
            completedActivityType: this.followForm.completedActivityType,
            contactType: this.followForm.contactType,
            level: this.isFail ? "F" : this.followForm.level,
            specIds: this.followForm.specIds.join(","),
            competitionSerieses: this.followForm.competitionSeries.join(","),
            testResult: this.followForm.testResult,
            testSpecId: +this.followForm.testSpecId,
            nextActivityType: this.followForm.nextActivityType,
            nextDate: parseInt(this.followForm.nextDate.getTime() / 1000),
            nextTestSpecId: +this.followForm.nextTestSpecId,
            remark: this.followForm.remark,
            comeDuration: this.followForm.comeDuration,
            isSuspend: this.followForm.isSuspend,
            event: this.followForm.event,
            quote: Number(this.followForm.quote),
            reserveComeDate: parseInt(
              this.followForm.reserveComeDate.getTime() / 1000
            ),
            failProvince: '',
            failCity: ''
          };
          if (params.event === 2 || params.event === 3) {
            params.nextDate = params.reserveComeDate;
          }
          if (
            params.completedActivityType === 2 ||
            params.completedActivityType === 3
          ) {
            params.event = 0;
          }
          if (params.event != 2 && params.event != 3) {
            params.reserveComeDate = 0;
          }
          if (params.contactType == "") {
            delete params.contactType;
          }
          if (this.isFail) {
            params.failReason = this.followForm.failReason;
            params.failDealerName = this.followForm.failDealerName;
          }
          if (
            this.followForm.failReason == 6 ||
            this.followForm.failReason == 2 ||
            this.followForm.failReason == 3
          ) {
            params.failSubReason = this.followForm.failSubReason;
          }
          if (this.isFail && this.followForm.failReason == 5) {
            params.failReasonDetail = this.followForm.failReasonDetail
          }
          if (
            this.isFail &&
            (this.followForm.failReason == 1 || this.followForm.failReason == 7)
          ) {
            params.failSeriesId = this.followForm.failSeriesId || null;
          }
          if (this.isFail && (this.followForm.failReason == 1 || this.followForm.failReason == 21)) {
            params.failPurchaseReason = this.followForm.failPurchaseReason.join(',');
          }
          if (this.isFail && this.followForm.failReason == 15) {
            params.failProvince = this.followForm.home[0];
            params.failCity = this.followForm.home[1];
          }
          if (!this.isFail && this.followForm.isSuspend) {
            params.resumeDuration = this.followForm.resumeDuration;
          }
          this.$httpAuth
            .post("/v2/appCustomerService/follow", params)
            .then(function (res) {
              parent.followDialog = false;
              parent.confirmLoading = false;
              parent.retrieveProfile();
            })
            .catch((error) => {
              parent.confirmLoading = false;
            });
        } else {
          this.confirmLoading = false;
        }
      });
    },
    toOrder5() {
      this.showMoreOrder3 = false;
      this.confirmLoading = true;
      var parent = this;
      let params = {
        dealerId: this.dealer.dealerId,
        customerId: this.customerId,
        dealId: this.deal.id,
        activityId: this.pendingActivity.id,
        completedActivityType: this.followForm.completedActivityType,
        contactType: this.followForm.contactType,
        level: this.isFail ? "F" : this.followForm.level,
        specIds: this.followForm.specIds.join(","),
        competitionSerieses: this.followForm.competitionSeries.join(","),
        testResult: this.followForm.testResult,
        testSpecId: +this.followForm.testSpecId,
        nextActivityType: this.followForm.nextActivityType,
        nextDate: parseInt(this.followForm.nextDate.getTime() / 1000),
        nextTestSpecId: +this.followForm.nextTestSpecId,
        remark: this.followForm.remark,
        comeDuration: this.followForm.comeDuration,
        isSuspend: this.followForm.isSuspend,
        event: this.followForm.event,
        quote: Number(this.followForm.quote),
        reserveComeDate: parseInt(
          this.followForm.reserveComeDate.getTime() / 1000
        ),
      };
      if (params.event === 2 || params.event === 3) {
        params.nextDate = params.reserveComeDate;
      }
      if (
        params.completedActivityType === 2 ||
        params.completedActivityType === 3
      ) {
        params.event = 0;
      }
      if (params.event != 2 && params.event != 3) {
        params.reserveComeDate = 0;
      }
      if (params.contactType == "") {
        delete params.contactType;
      }
      if (this.isFail) {
        params.failReason = this.followForm.failReason;
        params.failDealerName = this.followForm.failDealerName;
      }
      if (
        this.followForm.failReason == 6 ||
        this.followForm.failReason == 2 ||
        this.followForm.failReason == 3
      ) {
        params.failSubReason = this.followForm.failSubReason;
      }
      if (this.isFail && this.followForm.failReason == 5) {
        params.failReasonDetail = this.followForm.failReasonDetail
      }
      if (
        this.isFail &&
        (this.followForm.failReason == 1 || this.followForm.failReason == 7)
      ) {
        params.failSeriesId = this.followForm.failSeriesId || null;
      }
      if (!this.isFail && this.followForm.isSuspend) {
        params.resumeDuration = this.followForm.resumeDuration;
      }
      this.$httpAuth
        .post("/v2/appCustomerService/follow", params)
        .then(function () {
          parent.followDialog = false;
          parent.confirmLoading = false;
          parent.retrieveProfile();
        })
        .catch(() => {
          parent.confirmLoading = false;
        });
    },
    showRemarkDialog() {
      if (this.$refs["remarkForm"]) {
        this.$refs["remarkForm"].resetFields();
      }
      this.remarkForm = {
        remark: "",
      };
      this.remarkDialog = true;
      this.confirmLoading = false;
    },
    doRemark() {
      this.$refs["remarkForm"].validate((valid) => {
        if (valid) {
          var parent = this;
          parent.confirmLoading = true;
          this.$httpAuth
            .post("/v2/appCustomerService/remark", {
              dealerId: this.dealer.dealerId,
              customerId: this.customerId,
              dealId: this.deal.id,
              remark: this.remarkForm.remark,
            })
            .then(function () {
              parent.confirmLoading = false;
              parent.remarkDialog = false;
              parent.retrieveProfile();
            })
            .catch(() => {
              parent.confirmLoading = false;
            });
        }
      });
    },
    // 暂停回访/继续回访
    async toHandleVisit(val) {
      this.$confirm(`此操作将该客户${val ? '继续回访' : '暂停回访'}, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.confirmLoading = true;
          const url = val ? '/v2/appCustomerService/resume' : '/v2/appCustomerService/pause'
          this.$httpAuth
            .post(url, {
              dealerId: this.dealer.dealerId,
              customerId: this.customerId,
              dealId: this.deal.id,
              // resumeDuration: 7,
            })
            .then(() => {
              this.$message({
                type: "success",
                message: `${val ? '继续回访' : '暂停回访'}操作成功!`,
              });
              this.confirmLoading = false;
              this.retrieveProfile();
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
    doResume() {
      var title = "唤醒";
      if (this.deal.level == "D") {
        title = "继续跟进";
      }
      this.$confirm("此操作将该客户" + title + ", 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var parent = this;
          parent.confirmLoading = true;
          this.$httpAuth
            .post("/v2/appCustomerService/resume", {
              dealerId: this.dealer.dealerId,
              customerId: this.customerId,
              dealId: this.deal.id,
            })
            .then(function () {
              parent.$message({
                type: "success",
                message: title + "操作成功!",
              });
              parent.confirmLoading = false;
              parent.retrieveProfile();
            })
            .catch(() => {
              parent.confirmLoading = false;
            });
        })
        .catch(() => {
          parent.confirmLoading = false;
        });
    },

    showAssignDialog() {
      this.assignForm = {
        memberId: "",
        remark: "",
      };
      if (this.$refs["assignForm"]) {
        this.$refs["assignForm"].resetFields();
      }
      this.assignDialog = true;
      this.confirmLoading = false;

      this.assignMembers = [];
      if (!this.loginInfo.canResign) {
        for (var i = 0; i < this.members.length; i++) {
          var o = this.members[i];
          if (this.deal.ownerId == this.dealer.userId) {
            if (o.memberId != this.dealer.userId) {
              this.assignMembers.push(o);
            }
          } else {
            if (o.memberId != this.deal.ownerId) {
              this.assignMembers.push(o);
            }
          }
        }
        if (this.deal.ownerId != this.dealer.userId && !this.isAdmin) {
          this.assignMembers.push({
            userName: this.dealer.name,
            memberId: this.dealer.userId,
          });
        }
      } else {
        var parent = this;
        this.$httpAuth
          .post("/v2/appDealerManagerService/memberList", {
            dealerId: this.dealer.dealerId,
          })
          .then(function (response) {
            var arr = response.data.data;
            for (var i = 0; i < arr.length; i++) {
              var o = arr[i];
              if (parent.deal.ownerId == parent.dealer.userId) {
                if (o.memberId != parent.dealer.userId) {
                  parent.assignMembers.push(o);
                }
              } else {
                if (o.memberId != parent.deal.ownerId) {
                  parent.assignMembers.push(o);
                }
              }
            }
          });
      }
    },
    doAssign() {
      this.$refs["assignForm"].validate((valid) => {
        if (valid) {
          var parent = this;
          parent.confirmLoading = true;
          this.$httpAuth
            .post("/v2/appCustomerService/reassign", {
              dealerId: this.dealer.dealerId,
              customerId: this.customerId,
              dealId: this.deal.id,
              memberId: this.assignForm.memberId,
              remark: this.assignForm.remark,
            })
            .then(function () {
              parent.$message("客户再分配成功!");
              parent.assignDialog = false;
              parent.confirmLoading = false;
              parent.retrieveProfile();
            })
            .catch(() => {
              parent.confirmLoading = false;
            });
        }
      });
    },
    showFailDialog() {
      this.failForm = {
        failReason: "",
        remark: "",
        failSeriesId: "",
        failSubReason: "",
        failDealerName: "",
        failReasonDetail: ""
      };
      if (this.$refs["failForm"]) {
        this.$refs["failForm"].resetFields();
      }

      this.confirmLoading = false;
      this.getCityDealers();
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/getCompetitionSeriesList", {
          dealerId: this.dealer.dealerId,
          key: "",
        })
        .then(function (response) {
          parent.competitionSeries = response.data.data;
        });

      this.failDialog = true;
    },
    doFail() {
      this.$refs["failForm"].validate((valid) => {
        if (valid) {
          if (this.failForm.failReason == "") {
            this.$message({
              type: "error",
              message: "请选择战败原因",
            });
            return;
          }
          if (
            (this.failForm.failReason == 6 ||
              this.failForm.failReason == 2 ||
              this.failForm.failReason == 3) &&
            this.failForm.failSubReason == ""
          ) {
            this.$message({
              type: "error",
              message: "请选择战败次原因",
            });
            return;
          }
          if (this.failForm.failReason == 5 && this.failForm.failReasonDetail == "") {
            this.$message({
              type: "error",
              message: "请输入战败原因详情",
            });
            return;
          }
          let params = {
            dealerId: this.dealer.dealerId,
            customerId: this.customerId,
            dealId: this.deal.id,
            failReason: this.failForm.failReason,
            failSubReason: this.failForm.failSubReason,
            failDealerName: this.failForm.failDealerName,
            failReasonDetail: this.failForm.failReasonDetail,
            remark: this.failForm.remark,
          };
          if (this.failForm.failReason == 1 || this.failForm.failReason == 7) {
            params.failSeriesId = this.failForm.failSeriesId || null;
          }
          if (
            this.failForm.failReason != 6 &&
            this.failForm.failReason != 2 &&
            this.failForm.failReason != 3
          ) {
            delete params.failSubReason;
          }
          if (this.failForm.failReason != 5) {
            delete params.failReasonDetail;
          }
          var parent = this;
          parent.confirmLoading = true;
          this.$httpAuth
            .post("/v2/appCustomerService/fail", params)
            .then(function () {
              parent.$message("客户已被战败!");
              parent.failDialog = false;
              parent.confirmLoading = false;
              parent.retrieveProfile();
            })
            .catch(() => {
              parent.confirmLoading = false;
            });
        }
      });
    },
    changeReliveLevel() {
      var days = 0;
      for (var i = 0; i < this.followLevelOptions.length; i++) {
        var o = this.followLevelOptions[i];
        if (o.dataName == this.reliveForm.level) {
          days = o.dataValue;
          break;
        }
      }
      this.reliveForm.nextDate = this.$common.addDate(new Date(), days);
    },
    showReliveDialog() {
      this.reliveForm = {
        level: "N",
        memberId: this.deal.ownerId,
        memberName: this.deal.ownerName,
        specIds: [],
        nextActivityType: 1,
        nextDate: new Date(),
        nextTestSpecId: "",
        remark: "",
      };
      this.info.intendSerieses.forEach((item) => {
        this.reliveForm.specIds.push(item.id);
      });
      if (this.$refs["reliveForm"]) {
        this.$refs["reliveForm"].resetFields();
      }
      this.reliveDialog = true;
      this.confirmLoading = false;
      this.changeReliveLevel();
    },

    doRelive() {
      this.$refs["reliveForm"].validate((valid) => {
        if (valid) {
          var parent = this;
          parent.confirmLoading = true;
          this.$httpAuth
            .post("/v2/appCustomerService/relive", {
              dealerId: this.dealer.dealerId,
              customerId: this.customerId,
              dealId: this.deal.id,
              level: this.reliveForm.level,
              memberId: this.reliveForm.memberId,
              specIds: this.reliveForm.specIds.join(","),
              nextActivityType: this.reliveForm.nextActivityType,
              nextDate: parseInt(this.reliveForm.nextDate.getTime() / 1000),
              nextTestSpecId: +this.reliveForm.nextTestSpecId,
              remark: this.reliveForm.remark,
              customerImages: "",
              quoteImages: "",
              licenseFrontImage: "",
              licenseBackImage: "",
              testDriveImages: "",
              completedActivityType: 1,
            })
            .then(function () {
              parent.$message("客户已复活!");
              parent.reliveDialog = false;
              parent.confirmLoading = false;
              parent.retrieveProfile();
            })
            .catch(() => {
              parent.confirmLoading = false;
            });
        }
      });
    },

    showOrderDialog() {
      this.orderForm = {
        specId: [],
        orderDate: new Date(),
        deliverDate: "",
        color: "",
        colors: [],
        price: "",
        downPayment: "",
        payType: 1,
        payInsurance: false,
        remark: "",
      };
      if (this.deal.level == "O") {
        this.orderForm.color = this.deal.color;
        this.orderForm.price = this.deal.quote;
        this.orderForm.payInsurance = this.deal.payInsurance;
        this.orderForm.payType = this.deal.payType;
        this.orderForm.downPayment = this.deal.downPayment;
        var parent = this;
        if (this.deal.specId > 0) {
          this.$httpAuth
            .post("/v1/baseRpc/getSpec", {
              id: this.deal.specId,
            })
            .then(function (response) {
              parent.orderForm.specId = [
                response.data.spec.seriesId + "",
                response.data.spec.id + "",
              ];
              parent.orderForm.colors = response.data.spec.colors.split(",");
            })
            .catch(() => { });
        }
      }
      if (this.$refs["orderForm"]) {
        this.$refs["orderForm"].resetFields();
      }
      this.confirmLoading = false;
      this.orderDialog = true;
    },
    toOrder() {
      if (this.orderList2.length === 0) {
        sessionStorage.setItem("form", "customerDetail");
        this.$router.push({
          path: "/orderCreated",
          query: {
            customerId: this.customerId,
            dealId: this.info.dealId,
            customerName: this.customer.name,
            customerPhone: this.customer.mobile,
            type: this.customer.type,
            companyName: this.customer.companyName,
            adress: this.additional.address ? this.additional.address : "",
            //   identifyNo: this.additional.idNo,
          },
        });
      } else {
        this.showMoreOrder2 = true;
        console.log(1);
      }
    },
    toOrder2() {
      sessionStorage.setItem("form", "customerDetail");
      this.$router.push({
        path: "/orderCreated",
        query: {
          customerId: this.customerId,
          dealId: this.info.dealId,
          customerName: this.customer.name,
          customerPhone: this.customer.mobile,
          type: this.customer.type,
          companyName: this.customer.companyName,
          adress: this.additional.address ? this.additional.address : "",
          //   identifyNo: this.additional.idNo,
        },
      });
    },
    changeSpecColor(val) {
      var specId = val[1];
      var parent = this;
      parent.orderForm.colors = [];
      parent.orderForm.color = "";
      parent.deliverForm.colors = [];
      parent.deliverForm.color = "";
      this.$httpAuth
        .post("/v1/baseRpc/getSpec", {
          id: parseInt(specId),
        })
        .then(function (response) {
          parent.orderForm.colors = response.data.spec.colors.split(",");
          parent.deliverForm.colors = response.data.spec.colors.split(",");
        })
        .catch(() => { });
    },

    doOrder() {
      this.$refs["orderForm"].validate((valid) => {
        if (valid) {
          var specId = "";
          if (this.orderForm.specId.length == 2) {
            specId = this.orderForm.specId[1];
          }

          var parent = this;
          parent.confirmLoading = true;
          this.$httpAuth
            .post("/v2/appCustomerService/order", {
              dealerId: this.dealer.dealerId,
              customerId: this.customerId,
              dealId: this.deal.id,
              specId: +specId,
              orderDate: parseInt(new Date().getTime() / 1000),
              deliverDate: parseInt(
                this.orderForm.deliverDate.getTime() / 1000
              ),
              color: this.orderForm.color,
              price: +this.orderForm.price,
              payType: this.orderForm.payType,
              payInsurance: this.orderForm.payInsurance,
              remark: this.orderForm.remark,
              downPayment: +this.orderForm.downPayment,
            })
            .then(function () {
              parent.$message("客户已完成订车!");
              parent.confirmLoading = false;
              parent.orderDialog = false;
              parent.retrieveProfile();
            })
            .catch(() => {
              parent.confirmLoading = false;
            });
        }
      });
    },

    showDeliverDialog() {
      this.deliverForm = {
        specId: [],
        deliverDate: new Date(),
        color: this.deal.color,
        colors: [],
        downPayment: this.deal.downPayment,
        price: this.deal.quote,
        payType: this.deal.payType,
        payInsurance: this.deal.payInsurance,
        remark: "",
        nextRecall: true,
        nextDate: this.$common.addDate(new Date(), 1),
      };

      if (this.$refs["deliverForm"]) {
        this.$refs["deliverForm"].resetFields();
      }
      this.confirmLoading = false;
      this.deliverDialog = true;

      var parent = this;
      if (this.deal.specId > 0) {
        this.$httpAuth
          .post("/v1/baseRpc/getSpec", {
            id: this.deal.specId,
          })
          .then(function (response) {
            parent.deliverForm.specId = [
              response.data.spec.seriesId + "",
              response.data.spec.id + "",
            ];
            parent.deliverForm.colors = response.data.spec.colors.split(",");
          })
          .catch(() => { });
      }
    },

    doDeliver() {
      this.$refs["deliverForm"].validate((valid) => {
        if (valid) {
          var specId = "";
          if (this.deliverForm.specId.length == 2) {
            specId = this.deliverForm.specId[1];
          }

          var parent = this;
          parent.confirmLoading = true;
          this.$httpAuth
            .post("/v2/appCustomerService/deliver", {
              dealerId: this.dealer.dealerId,
              customerId: this.customerId,
              dealId: this.deal.id,
              specId: +specId,
              deliverDate: parseInt(
                this.deliverForm.deliverDate.getTime() / 1000
              ),
              color: this.deliverForm.color,
              price: +this.deliverForm.price,
              downPayment: +this.deliverForm.downPayment,
              payType: this.deliverForm.payType,
              payInsurance: this.deliverForm.payInsurance,
              remark: this.deliverForm.remark,
              nextRecall: this.deliverForm.nextRecall,
              nextDate: parseInt(this.deliverForm.nextDate.getTime() / 1000),
            })
            .then(function () {
              parent.$message("客户已完成交车!");
              parent.confirmLoading = false;
              parent.deliverDialog = false;
              parent.retrieveProfile();
            })
            .catch(() => {
              parent.confirmLoading = false;
            });
        }
      });
    },

    showRecallDialog() {
      this.recallForm = {
        contactStatus: 1,
        nextRecall: true,
        nextDate: this.$common.addDate(new Date(), 1),
        remark: "",
        birthdayRecall: false,
      };

      if (this.$refs["recallForm"]) {
        this.$refs["recallForm"].resetFields();
      }
      this.confirmLoading = false;
      this.recallDialog = true;
    },

    doRecall() {
      this.$refs["recallForm"].validate((valid) => {
        if (valid) {
          var parent = this;
          parent.confirmLoading = true;
          this.$httpAuth
            .post("/v2/appCustomerService/recall", {
              dealerId: this.dealer.dealerId,
              customerId: this.customerId,
              dealId: this.deal.id,
              completedDate: parseInt(new Date().getTime() / 1000),
              contactStatus: this.recallForm.contactStatus,
              remark: this.recallForm.remark,
              nextRecall: this.recallForm.nextRecall,
              birthdayRecall: this.recallForm.birthdayRecall,
              nextDate: parseInt(this.recallForm.nextDate.getTime() / 1000),
            })
            .then(function () {
              parent.$message("完成客户回访");
              parent.recallDialog = false;
              parent.confirmLoading = false;
              parent.retrieveProfile();
            })
            .catch(() => {
              parent.confirmLoading = false;
            });
        }
      });
    },

    confirmFail() {
      this.$confirm("此操作将同意该客户战败申请, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var parent = this;
          parent.confirmLoading = true;
          this.$httpAuth
            .post("/v2/appVerifyService/confirmFail", {
              dealerId: this.dealer.dealerId,
              customerId: this.customerId,
              dealId: this.deal.id,
            })
            .then(function () {
              parent.$message("该客户已战败审核通过");
              parent.confirmLoading = false;
              parent.retrieveProfile();
            })
            .catch(() => {
              parent.confirmLoading = false;
            });
        })
        .catch(() => {
          parent.confirmLoading = false;
        });
    },

    changeRejectFailLevel() {
      var days = 0;
      for (var i = 0; i < this.followLevelOptions.length; i++) {
        var o = this.followLevelOptions[i];
        if (o.dataName == this.rejectFailForm.level) {
          days = o.dataValue;
          break;
        }
      }
      this.rejectFailForm.nextDate = this.$common.addDate(new Date(), days);
    },
    showRejectFailDialog() {
      this.rejectFailForm = {
        memberId: this.deal.ownerId,
        memberName: "",
        specIds: [],
        nextActivityType: 1,
        nextDate: new Date(),
        nextTestSpecId: "",
        remark: "",
        crossRecall: "",
      };
      if (this.$refs["rejectFailForm"]) {
        this.$refs["rejectFailForm"].resetFields();
      }
      this.confirmLoading = false;
      this.rejectFailDialog = true;
      this.info.intendSerieses.forEach((item) => {
        this.rejectFailForm.specIds.push(item.id);
      });
      this.changeRejectFailLevel();
    },

    doRejectFail() {
      if (this.rejectFailForm.crossRecall === "") {
        this.$message({ type: "error", message: "请选择交叉回访" });
        return;
      }
      if (this.rejectFailForm.memberId == "") {
        this.$message({ type: "error", message: "请选择客户经理" });
        return;
      }
      if (this.rejectFailForm.remark == "") {
        this.$message({ type: "error", message: "驳回原因不能为空" });
        return;
      }
      this.$refs["rejectFailForm"].validate((valid) => {
        if (valid) {
          var parent = this;
          parent.confirmLoading = true;
          this.$httpAuth
            .post("/v2/appVerifyService/rejectFail", {
              dealerId: this.dealer.dealerId,
              customerId: this.customerId,
              dealId: this.deal.id,
              level: "N",
              memberId: this.rejectFailForm.memberId,
              specIds: this.rejectFailForm.specIds.join(","),
              nextActivityType: 1,
              nextDate: parseInt(this.rejectFailForm.nextDate.getTime() / 1000),
              remark: this.rejectFailForm.remark,
              crossRecall: this.rejectFailForm.crossRecall,
            })
            .then(function () {
              parent.$message("客户已被驳回战败申请!");
              parent.confirmLoading = false;
              parent.rejectFailDialog = false;
              parent.retrieveProfile();
            })
            .catch(() => {
              parent.confirmLoading = false;
            });
        }
      });
    },

    showTagDialog() {
      this.confirmLoading = false;
      this.tagDialog = true;
    },

    checkTag(item, category) {
      if (this.tags.join(" ").indexOf(item) == -1) {
        this.tags.push(item);
        if (category.dataName != "其他") {
          category.dataDisplay.split(" ").forEach((t) => {
            if (item != t) {
              if (this.tags.indexOf(t) != -1) {
                this.tags.splice(this.tags.indexOf(t), 1);
              }
            }
          });
        }
      } else {
        var newTags = [];
        for (var i = 0; i < this.tags.length; i++) {
          var o = this.tags[i];
          if (o != item) {
            newTags.push(o);
          }
        }
        this.tags = newTags;
      }
    },
    doSaveTag() {
      var parent = this;
      parent.confirmLoading = true;
      this.$httpAuth
        .post("/v1/customerRpc/updateTag", {
          dealerId: this.dealer.dealerId,
          customerId: this.customerId,
          tag: this.tags.join(" ").trim(),
        })
        .then(function () {
          parent.tagDialog = false;
          parent.confirmLoading = false;
          parent.retrieveProfile();
        })
        .catch(() => {
          parent.confirmLoading = false;
        });
    },
    showEditDialog() {
      const { buyProvince, buyCity, buyArea } = this.additional;
      // 购车地区初始化
      const buyCarAddress = buyProvince && buyCity ? [buyProvince, buyCity, buyArea]: []
      this.editForm = {
        name: this.customer.name,
        mobile: this.customer.mobile,
        weixin: this.customer.weixin,
        gender: this.customer.gender,
        type: this.customer.type,
        companyName: this.customer.companyName,
        fromSource: this.customer.FromSource,
        otherSource: this.customer.customSource
          ? Number(this.customer.customSource)
          : "",
        secondardPhone: this.customer.secondaryPhone,
        fromType: this.customer.fromType,
        onlineSourceName: this.customer.onlineSourceName,
        businessType: this.customer.businessType,
        buyCount: this.customer.buyCount,
        // 购车地区
        buyCarAddress,
        buyProvince,
        buyCity,
        buyArea,
        competitionSeries: [],
        specIds: [],
        budget: this.deal.budget == 0 ? 1 : this.deal.budget,
        buycarDate:
          this.customer.buycarDate == 0
            ? ""
            : this.parseTime(this.customer.buycarDate),
        addition: {
          province: this.additional.province,
          city: this.additional.city,
          area: this.additional.area,
          address: this.additional.address,
          idNo: this.additional.idNo,
          birthday: this.additional.birthday,
          qq: this.additional.qq,
        },
        identifyType: this.additional.identifyType ||1,
        identifyNo: this.additional.idNo,
        identifyNo2: this.additional.idNo,
        identifyNo3: this.additional.idNo,
        identifyNos: this.additional.idNo,
        addPurchaseOldSeriesId: this.purchaseOldSeries && this.purchaseOldSeries.id
      };
      // 线下来源：4: 转介绍 96：新媒体 104： 跨品牌转介绍
      const disabledFromSourceList = [4, 96, 104]
      // 当前选中的来源是否在不可以修改来源列表中
      const isDisabledList = disabledFromSourceList.includes(this.editForm.fromSource)
      this.fromSourceOptions = this.fromSourceOptions.map(item => {
        // 当前项的来源是否在禁用列表中
        const disabledSource = disabledFromSourceList.includes(item.dataValue)
        const disabled = isDisabledList || disabledSource
        return {
          ...item,
          disabled
        }
      })
      if (this.editForm.mobile === '') this.isNoPhone = true;
      // this.home[0] = this.additional.province;
      // this.home[1] = this.additional.city;
      this.info.competitionSeries.forEach((item) => {
        this.editForm.competitionSeries.push(item.id);
      });
      this.info.intendSerieses.forEach((item) => {
        this.editForm.specIds.push(item.id);
      });
      this.confirmLoading = false;
      this.editDialog = true;
      // 初始化省市区列表
      if (!!buyProvince) {
        // 获取市列表
        this.getCityList(buyProvince).then(res => {
          this.buyCarCityList = res.data.data;
        })
        const params = {
          dealerId: this.dealer.dealerId,
          province: buyProvince,
          city:buyCity
        }
        // 获取区域列表
        this.getAreaList(params).then(res => {
            this.buyCarAreaList = res.data.data;
        })
      }
      this.$nextTick(() => {
        this.$refs["editForm"].clearValidate()
      })
    },
    doUpdate() {
      this.$httpAuth
        .post("/v2/appWxCustomerService/checkExist", {
          dealerId: this.dealer.dealerId,
          phone: this.editForm.mobile,
          customerId: this.customerId,
        }).then(res => {
          if (res.data.isExisted && !res.data.isMerged) {
            this.MergeInfo = { ...res.data.customer }
            this.mergeLog = true;
          } else {
            this.$refs["editForm"].validate((valid) => {
              if (valid) {
                if (this.home.length !== 0) {
                  this.editForm.addition.province = this.home[0];
                  this.editForm.addition.city = this.home[1];
                }
                if (this.editForm.fromSource == 99 && !this.editForm.otherSource) {
                  this.$message({
                    message: "请选择自定义来源",
                    type: "warning",
                  });
                  return;
                }
                 // 购车地区
                const [buyProvince, buyCity, buyArea] = this.editForm.buyCarAddress
                let params = {
                  dealerId: this.dealer.dealerId,
                  customerId: this.customerId,
                  dealId: this.deal.id,
                  name: this.editForm.name,
                  mobile: this.editForm.mobile,
                  weixin: this.editForm.weixin,
                  gender: this.editForm.gender,
                  type: this.editForm.type,
                  companyName: this.editForm.companyName,
                  fromSource: this.editForm.fromSource,
                  otherSource: this.editForm.otherSource + "",
                  addition: {
                    province: this.editForm.addition.province,
                    city: this.editForm.addition.city,
                    area: this.editForm.addition.area,
                    address: this.editForm.addition.address,
                    idNo: "",
                    identifyType: this.editForm.identifyType,
                    birthday: this.editForm.addition.birthday,
                    qq: this.editForm.addition.qq,
                  },
                  secondardPhone: this.editForm.secondardPhone,
                  tags: this.customer.tag,
                  isReplace: true,
                  businessType: this.editForm.businessType,
                  customSource: this.editForm.customSource,
                  buyCount: this.editForm.buyCount,
                  // 购车地区
                  buyProvince,
                  buyCity, 
                  buyArea,
                  budget: this.editForm.budget,
                  competitionSerieses: this.editForm.competitionSeries.join(","),
                  specIds: this.editForm.specIds.join(","),
                  buycarDate: "",
                };
                if (
                  this.editForm.buycarDate ==
                  this.parseTime(this.customer.buycarDate)
                ) {
                  params.buycarDate = this.customer.buycarDate;
                } else {
                  params.buycarDate =
                    this.editForm.buycarDate != ""
                      ? parseInt(this.editForm.buycarDate.getTime() / 1000)
                      : 0;
                }
                if (this.editForm.identifyType === 1) {
                  params.addition.idNo = this.editForm.identifyNo;
                } else if (this.editForm.identifyType === 2) {
                  params.addition.idNo = this.editForm.identifyNo2;
                } else if (this.editForm.identifyType === 3) {
                  params.addition.idNo = this.editForm.identifyNo3;
                } else {
                  params.addition.idNo = this.editForm.identifyNos;
                }
                this.confirmLoading = true;
                this.$httpAuth
                  .post("/v2/appCustomerService/edit", params)
                  .then(response => {
                    if (response.data.code == 202 && response.data.status== -2) {
                      this.blcInfo = {
                        name: params.name,
                        mobile: params.mobile,
                        idNo: params.addition.idNo,
                        detail: response.data.detail
                      }
                      this.showBlcTips = true;
                      this.confirmLoading = false;
                      return;
                    }
                    if (response.data.weixinClueExisted) {
                      this.tipDialog = true;
                    }
                    this.editDialog = false;
                    this.confirmLoading = false;
                    this.retrieveProfile();
                  })
                  .catch(() => {
                    this.confirmLoading = false;
                  });
              }
            });
          }
        })

    },
    mergeConfim() {
      this.confirmLoading = true;
      this.$httpAuth
        .post("/v2/appWxCustomerService/merge", {
          dealerId: this.dealer.dealerId,
          masterCustomerId: this.MergeInfo.id,
          slaveCustomerId: this.customerId
        }).then(() => {
          this.$message({ type: "success", message: "合并客户申请成功" });
          this.confirmLoading = false;
          this.editDialog = false;
          this.mergeLog = false;
          this.$router.push({
            path: "/customer/list",
          });
        }).catch(() => { this.confirmLoading = false; })
    },
    showtestShareDialog(id) {
      this.$httpAuth
        .post("/v2/appCustomerService/testShareDetail", {
          dealerId: this.dealer.dealerId,
          shareId: Number(id),
        })
        .then((res) => {
          this.testShareDetailForm = res.data;
          this.testShareTimelines = res.data.data;
          this.testShareDetailDialog = true;
        });
    },
    /**
     * 展示企微智能总结弹框
     * @param {Object} row - 表格行数据，包含企微跟进记录信息
     */
    showWechatSummaryDialog(row) {
      // 总结内容直接取行数据中的 wxSummary 字段，纯文本展示，无需解析
      this.wechatSummaryContent = row.wxSummary || '暂无内容';
      this.wechatSummaryDialog = true;
    },
    /**
     * 展示智慧号通话详情弹框
     * @param {Object} row - 表格行数据，subject 为"智慧号拨打客户电话"的记录
     */
    showSmartCallDetailDialog(row) {
      // 边界：行数据缺失时兜底占位文案，纯文本展示，格式与企微智能总结弹框一致
      this.smartCallDetailContent = row.wxSummary || row.content || '暂无内容';
      this.smartCallDetailDialog = true;
    },
    /**
     * 打开通话记录编辑弹框
     * @param {Object} row - 通话记录行数据
     */
    openCallEditDialog(row) {
      // 验证是否在3天修改时限内
      const now = new Date();
      // 边界：createdAt 为秒级时间戳（约1e9量级），Date 构造函数按毫秒解析，需先乘1000；毫秒级（1e12以上）则直接使用
      const rawTs = Number(row.createdAt);
      const createdAt = new Date(rawTs < 1e12 ? rawTs * 1000 : rawTs);
      const diffDays = Math.floor((now - createdAt) / (1000 * 60 * 60 * 24));

      if (diffDays > 3) {
        this.$message.warning("只允许维护近3日内的通话记录");
        return;
      }

      // 回填当前内容：content 格式为"通话时长X秒\n跟进内容: XXX"，编辑时仅回填"跟进内容:"之后的文本
      // 边界1：兼容半角"跟进内容:"与全角"跟进内容："两种冒号（不同端写入格式不一）
      // 边界2：content 不含该标记（如仅有"通话时长2秒"）时，说明无跟进内容，回填空串
      let content = row.content || "";
      const markerMatch = content.match(/跟进内容[:：]/);
      if (markerMatch) {
        content = content.substring(markerMatch.index + markerMatch[0].length);
      } else {
        content = "";
      }
      // 提取"通话时长X秒"前缀（换行符之前的部分），保存时原样拼回，避免丢失时长信息
      // 边界：无换行符时（如仅有跟进内容或空content）前缀取空串
      const durationPrefix = row.content ? (row.content.split("\n")[0] + "\n") : "";
      this.callEditForm.id = row.id;
      this.callEditForm.durationPrefix = durationPrefix;
      this.callEditForm.content = content.trim();
      this.callEditDialog = true;
    },
    /**
     * 通话编辑弹框关闭时的处理
     */
    handleCallEditDialogClose() {
      if (this.$refs.callEditFormRef) {
        this.$refs.callEditFormRef.resetFields();
      }
      this.callEditForm.id = null;
      this.callEditForm.content = "";
    },
    /**
     * 保存通话记录编辑内容
     */
    handleCallEditSave() {
      if (!this.callEditForm.content || this.callEditForm.content.trim() === "") {
        this.$message.warning("请输入跟进内容");
        return;
      }

      this.callEditLoading = true;
      this.$httpAuth
        .post("/v2/appCustomerService/customerLineUpdate", {
          dealerId: this.dealer.dealerId,
          timeLineId: this.callEditForm.id,
          // 提交时拼回"通话时长X秒\n"前缀与"跟进内容："标记，保持轨迹展示格式不变
          content: this.callEditForm.durationPrefix + "跟进内容：" + this.callEditForm.content.trim(),
        })
        .then((res) => {
          this.callEditLoading = false;
          // 响应结构：{ success: bool, msg: string }，根据 success 判断更新结果
          const data = (res && res.data) || {};
          if (data.success) {
            this.$message.success(data.msg || "保存成功");
            this.callEditDialog = false;
            // 更新成功后刷新客户详情（含跟进记录列表）
            this.retrieveProfile();
          } else {
            // 失败时展示后端返回的原因，无 msg 时兜底通用提示
            this.$message.error(data.msg || "保存失败，请稍后重试");
          }
        })
        .catch((error) => {
          this.callEditLoading = false;
          this.$message.error("保存失败，请稍后重试");
          console.error("保存通话记录失败:", error);
        });
    },
    showClueDetailDialog(id) {
      var parent = this;
      this.$httpAuth
        .post("/v2/appClueService/detail", {
          dealerId: this.dealer.dealerId,
          clueId: id,
        })
        .then(function (response) {
          
          parent.clueDetailDialog = true;
          parent.clueDetailForm = response.data.data;
          if (parent.clueDetailForm.historySpec == "") {
            parent.clueDetailForm.historySpec = "{}";
          }
          if (parent.clueDetailForm.attentionSeries == "") {
            parent.clueDetailForm.attentionSeries = "{}";
          }
          parent.clueDetailForm.activityDesc = [parent.clueDetailForm.clueSource, parent.clueDetailForm.siteDesc].filter(e => !!e).join('-')
          
          const timeline = response.data.timeline?.map((item, index) =>  {
            const remark = item.remark
            const remarkPic = parent.transformWxPic(remark)
            return  {
              ...item,
              remark: parent.transformRemark(remark),
              remarkPic
            }
          }) 

          parent.clueTimelines = timeline;
          parent.confirmLoading = false;
        });
    },
    showClueDetailDialog2(row, audioType = 'audioUrl') {
      this.$httpAuth
        .post("/v2/appCustomerService/thirdCallDetail", {
          dealerId: row.dealerId,
          callId: row.onlineCustomerId,
        })
        .then((res) => {
          const {data = {}} = res.data || {}
          this.audioUrl = data[audioType] || row.audioUrl;
          this.contentList = JSON.parse(res.data.data.contentList);
          this.asrDialog = true;
          this.$nextTick(() => {
            this.$refs.audio.load();
          });
        });
    },
    informCome() {
      this.$confirm("此操作将确认该客户到店, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var parent = this;
          parent.confirmLoading = true;
          this.$httpAuth
            .post("/v2/appCustomerDeskService/informCome", {
              dealerId: this.dealer.dealerId,
              customerId: this.customerId,
            })
            .then(function () {
              parent.$message("确认到店完成");
              parent.confirmLoading = false;
              parent.retrieveProfile();
            })
            .catch(() => {
              parent.confirmLoading = false;
            });
        })
        .catch(() => {
          parent.confirmLoading = false;
        });
    },
    showNewCustomerDialog() {
      const { buyProvince: additionalBuyProvince, buyCity:additionalBuyCity, buyArea: additionalBuyArea } = this.additional;
      const buyProvince = additionalBuyProvince || this.dealerProvince;
      const buyCity = additionalBuyCity || this.dealerCity;
      const buyArea = additionalBuyArea || this.dealerArea;
      // 购车地区初始化
      const buyCarAddress = buyProvince && buyCity ? [buyProvince, buyCity, buyArea]: []
      const fromSource = this.customer.FromSource || (this.newFromSourceOptions ? this.newFromSourceOptions[0].dataValue : '');
      this.newCustomer = {
        name: this.customer.name,
        mobile: this.customer.mobile,
        weixin: this.customer.weixin,
        gender: this.customer.gender,
        type: this.customer.type,
        companyName: this.customer.companyName,
        otherSource: Number(this.customer.customSource),
        fromSource,
        customSource: this.customer.customerSource,
        secondardPhone: this.customer.secondardPhone,
        specIds: [],
        competitionSerieses: [],
        budget: 1,
        businessType: 1,
        level: "N",
        nextActivityType: 1,
        nextDate: new Date(),
        buycarDate: '',
        nextTestSpecId: "",
        remark: "",
        buyCount: 0,
         // 购车地区
         buyCarAddress,
        buyProvince,
        buyCity,
        buyArea,
        addition: {
          province: this.additional.province,
          city: this.additional.city,
          address: this.additional.address,
          idNo: this.additional.idNo,
          birthday: this.additional.birthday,
          qq: this.additional.qq,
        },
        addPurchaseOldSeriesId: ''
      };
      this.home[0] = this.additional.province;
      this.home[1] = this.additional.city;
      this.changeLevel();
      this.newDialog = true;
      // 初始化省市区列表
      if (!!buyProvince) {
        // 获取市列表
        this.getCityList(buyProvince).then(res => {
          this.reBuyCarCityList = res.data.data;
        })
        const params = {
          dealerId: this.dealer.dealerId,
          province: buyProvince,
          city:buyCity
        }
        // 获取区域列表
        this.getAreaList(params).then(res => {
            this.reBuyCarAreaList = res.data.data;
        })
      }
      if (this.$refs["newForm"]) {
        this.$refs["newForm"].resetFields();
        // this.$refs["newForm"].clearValidate()
      }
    },
    getCompetitionSeriesesOptions() {
      this.$httpAuth
        .post("/v1/dealerRpc/getCompetitionSeriesList", {
          dealerId: this.dealer.dealerId,
          key: "",
        })
        .then(response => {
          this.competitionSeriesesOptions = response.data.data;
        });
    },
    changeLevel() {
      var days = 0;
      for (var i = 0; i < this.followLevelOptions.length; i++) {
        var o = this.followLevelOptions[i];
        if (o.dataName == this.newCustomer.level) {
          days = o.dataValue;
          break;
        }
      }
      this.newCustomer.nextDate = this.$common.addDate(new Date(), days);
    },

    doAdd() {
      this.$refs["newForm"].validate((valid) => {
        if (valid) {
          if (
            this.newCustomer.fromSource == 99 &&
            !this.newCustomer.otherSource
          ) {
            this.$message({
              message: "请选择自定义来源",
              type: "warning",
            });
            return;
          }

          if (this.home.length !== 0) {
            this.newCustomer.addition.province = this.home[0];
            this.newCustomer.addition.city = this.home[1];
          }
          this.confirmLoading = true;
          // 购车地区
          const [buyProvince, buyCity, buyArea] = this.newCustomer.buyCarAddress
          let params = {
              dealerId: this.dealer.dealerId,
              name: this.newCustomer.name,
              mobile: this.newCustomer.mobile,
              weixin: this.newCustomer.weixin,
              gender: this.newCustomer.gender,
              type: this.newCustomer.type,
              companyName: this.newCustomer.companyName,
              fromSource: this.newCustomer.fromSource,
              otherSource: this.newCustomer.otherSource + "",
              addition: {
                province: this.newCustomer.addition.province,
                city: this.newCustomer.addition.city,
                address: this.newCustomer.addition.address,
                idNo: this.newCustomer.addition.idNo,
                identifyType: this.orderIdentifyTypeDics?.[0]?.dataValue ?? "",// 证件类型 固定身份证类型
                birthday: this.newCustomer.addition.birthday,
                qq: this.newCustomer.addition.qq,
              },
              secondardPhone: this.newCustomer.secondardPhone,
              tags: "",
              level: this.newCustomer.level,
              specIds: this.newCustomer.specIds.join(","),
              competitionSerieses: this.newCustomer.competitionSerieses.join(
                ","
              ),
              budget: this.newCustomer.budget,
              nextActivityType: this.newCustomer.nextActivityType,
              nextDate: parseInt(this.newCustomer.nextDate.getTime() / 1000),
              buycarDate:
                this.newCustomer.buycarDate != ""
                  ? parseInt(this.newCustomer.buycarDate.getTime() / 1000)
                  : 0,
              nextTestSpecId: +this.newCustomer.nextTestSpecId,
              isRepace: true,
              // 购车地区
              buyProvince,
              buyCity, 
              buyArea,
              businessType: this.newCustomer.businessType,
              customSource: this.newCustomer.customSource,
              buyCount: this.newCustomer.buyCount,
              remark: this.newCustomer.remark,
              newType: 2,
              oldCustomerId: this.customer.id,
            }
          this.$httpAuth
            .post("/v2/appCustomerService/add", params)
            .then((res) => {
              if (res.data.code == 202 && res.data.status== -2) {
                this.blcInfo = {
                  name: params.name,
                  mobile: params.mobile,
                  idNo: params.addition.idNo,
                  detail: res.data.detail
                }
                this.showBlcTips = true;
                this.confirmLoading = false;
                return;
              }
              this.newDialog = false;
              this.confirmLoading = false;
              this.$router.push({
                path: "/customer/list",
              });
            })
            .catch(() => {
              parent.confirmLoading = false;
            });
        }
      });
    },
    parseTime(time, cFormat) {
      if (arguments.length === 0) {
        return null;
      }
      const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
      let date;
      if (typeof time === "object") {
        date = time;
      } else {
        if (("" + time).length === 10) time = parseInt(time) * 1000;
        date = new Date(time);
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
      };
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        if (key === "a")
          return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
        if (result.length > 0 && value < 10) {
          value = "0" + value;
        }
        return value || 0;
      });
      return time_str;
    },
    // 是否智蛛订单 1-智蛛订单 2-盲订订单
    isZZOrder(data) {
      return data.zzType === 1
    },
    handleRefundSubmit() {
      this.$confirm('是否确认通过退款申请，审核通过后，退款金额退款至客户支付账户中', '退款审核', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true
        }).then(() => {
            this.$httpAuth
              .post("/v2/appVerifyService/confirmRefund", {
                dealerId: this.dealer.dealerId,
                orderId: this.orderList[0].id,
              })
              .then(res => {
                this.getOrder();
              });
        }).catch(() => {
                
        });
    },
    transformRemark(remark) {
      const separator = "客户微信截图:";
      const parts = remark.split(separator);
      return parts[0]
    },
    transformWxPic(remark) {
      const separator = "客户微信截图: ";
      const parts = remark.split(separator);
      const result = parts[1] ? parts[1].split(',') : []
      return result
    },
  },
  watch: {
    "followForm.failReason"(value) {
      this.followForm.failSubReason = "";
      this.followForm.failReasonDetail = "";
      this.followForm.failSeriesId = "";
      this.newFailReasons.forEach((item) => {
        if (item.dataValue == value) {
          this.failSubReasonOption = item.remark.split(",");
        }
      });
    },
    "failForm.failReason"(value) {
      this.failForm.failSubReason = "";
      this.failForm.failReasonDetail = "";
      this.failForm.failSeriesId = "";
      this.newFailReasons.forEach((item) => {
        if (item.dataValue == value) {
          this.failSubReasonOption = item.remark.split(",");
        }
      });
    },
    isFail(value) {
      if (!value) {
        this.followForm.failReason = "";
        this.followForm.failSeriesId = "";
        this.followForm.failSubReason = "";
        this.followForm.failReasonDetail = "";
        this.followForm.failDealerName = "";
        this.followForm.isSuspend = false;
        this.followForm.resumeDuration = "";
      }
    },
  },
  computed: {
    newFromSourceOptions() {
       if (!this.baseInfo || !Array.isArray(this.baseInfo.customerFromSources)) {
            return [];
        }
        // 去掉跨品牌转介绍和新媒体的客户来源
        return this.baseInfo.customerFromSources.filter((item) => item.dataDisplay != '跨品牌转介绍' && item.dataDisplay != '新媒体')
    },
    qiWeiTag() {
      return this.customer.qiWeiTag ? JSON.parse(this.customer.qiWeiTag) : [];
    }
  },
};
</script>
<style scoped>
.add-title {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: rgba(10, 18, 32, 0.64);
  letter-spacing: normal;
  margin-bottom: 15px;
  margin-top: 10px;
}

.el-loading-mask {
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.5);
}

.orderLog .el-dialog__body {
  padding: 10px 20px 10px 20px;
  max-height: 500px;
  overflow-y: auto;
}

.orderBox {
  border: 1px solid #e5e5e5;
  padding-bottom: 10px;
  margin-bottom: 10px;
  position: relative;
}

.orderBox .detail {
  position: absolute;
  color: #409eff;
  bottom: 15px;
  right: 40px;
  cursor: pointer;
  font-weight: 500;
}

.orderBox .appo {
  position: absolute;
  right: 40px;
  top: 15px;
}


.ps {
  text-align: center;
  margin-top: 20px;
}

.records-text {
  width: 100%;
  height: 450px;
  margin-top: 16px;
}

.records-text .texts {
  width: 100%;
  height: 100%;
  background: #fafafb;
  padding: 19px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow-y: auto;
}

.records-text .texts .text {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  margin-bottom: 0px;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.records-text .texts .text.right {
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
}

.records-text .texts .text.right .t2 {
  background: #506eff;
  color: #ffffff;
}

.records-text .texts .text .t1 {
  height: 40px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #717171;
  line-height: 20px;
}

.records-text .texts .text .t1 img {
  width: 40px;
}

.records-text .texts .text .t2 {
  display: inline-block;
  max-width: 400px;
  background: #ffffff;
  border-radius: 0px 20px 0px 20px;
  padding: 15px 11px 11px 12px;
  margin: 6px 0;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #373737;
  line-height: 17px;
  margin-left: 50px;
  margin-top: -20px;
}

.records-text .texts .text .t2.selected {
  background-color: #b4ee7c;
}

.records-text .texts .text .t2.user {
  border-radius: 20px 0px 20px 0px;
  margin: -20px 50px 0 0;
}

.records-text .texts .text .t3 {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #4c4c4c;
  line-height: 17px;
  text-indent: 5px;
}

.records-text .texts::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background: transparent;
}

.records-text .texts::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
}

.records-text .texts:hover::-webkit-scrollbar-thumb {
  background: rgba(135, 135, 135, 0.4);
}

.records-text .texts:hover::-webkit-scrollbar-track {
  background: rgba(135, 135, 135, 0.1);
}

audio {
  width: 100%;
  height: 50px;
  margin-top: 10px;
}
.buy-car-address /deep/.el-form-item__label::before{
  display: none;
}

.form_item {
  margin-bottom: 15px !important;
}

.submit-fo {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.pss {
  width: 100%;
  height: 50px;
  font-size: 12px;
  line-height: 20px;
}

/* 企微智能总结弹框样式 */
.wechat-summary-dialog .wechat-summary-content {
  min-height: 200px;
  max-height: 500px;
  overflow-y: auto;
  padding: 10px;
}

.wechat-summary-dialog .wechat-summary-body {
  line-height: 1.8;
  font-size: 14px;
  color: #303133;
}

.wechat-summary-dialog .wechat-summary-body h1,
.wechat-summary-dialog .wechat-summary-body h2,
.wechat-summary-dialog .wechat-summary-body h3,
.wechat-summary-dialog .wechat-summary-body h4,
.wechat-summary-dialog .wechat-summary-body h5,
.wechat-summary-dialog .wechat-summary-body h6 {
  margin: 16px 0 8px 0;
  font-weight: 600;
  line-height: 1.4;
}

.wechat-summary-dialog .wechat-summary-body h1 { font-size: 20px; }
.wechat-summary-dialog .wechat-summary-body h2 { font-size: 18px; }
.wechat-summary-dialog .wechat-summary-body h3 { font-size: 16px; }
.wechat-summary-dialog .wechat-summary-body h4,
.wechat-summary-dialog .wechat-summary-body h5,
.wechat-summary-dialog .wechat-summary-body h6 { font-size: 14px; }

.wechat-summary-dialog .wechat-summary-body p {
  margin: 8px 0;
}

.wechat-summary-dialog .wechat-summary-body ul,
.wechat-summary-dialog .wechat-summary-body ol {
  margin: 8px 0;
  padding-left: 24px;
}

.wechat-summary-dialog .wechat-summary-body li {
  margin: 4px 0;
  line-height: 1.6;
}

.wechat-summary-dialog .wechat-summary-body code {
  background-color: #f5f7fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: Monaco, Menlo, monospace;
  font-size: 13px;
  color: #e6a23c;
}

.wechat-summary-dialog .wechat-summary-body pre {
  background-color: #f5f7fa;
  padding: 12px;
  border-radius: 4px;
  overflow-x: auto;
  margin: 12px 0;
}

.wechat-summary-dialog .wechat-summary-body pre code {
  background: none;
  padding: 0;
  color: #303133;
}

.wechat-summary-dialog .wechat-summary-body blockquote {
  margin: 12px 0;
  padding: 8px 16px;
  border-left: 4px solid #409eff;
  background-color: #f5f7fa;
  color: #606266;
}

.wechat-summary-dialog .wechat-summary-body a {
  color: #409eff;
  text-decoration: none;
}

.wechat-summary-dialog .wechat-summary-body a:hover {
  text-decoration: underline;
}

.wechat-summary-dialog .wechat-summary-body strong {
  font-weight: 600;
}

.wechat-summary-dialog .wechat-summary-body em {
  font-style: italic;
}

.wechat-summary-dialog .wechat-summary-body del {
  color: #909399;
}

.wechat-summary-dialog .wechat-summary-body hr {
  border: none;
  border-top: 1px solid #e5e5e5;
  margin: 16px 0;
}

.wechat-summary-dialog .wechat-summary-error {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #f56c6c;
  font-size: 14px;
}

.wechat-summary-dialog .wechat-summary-error i {
  margin-right: 8px;
  font-size: 18px;
}

.wechat-summary-dialog .wechat-summary-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #909399;
  font-size: 14px;
}

.wechat-summary-dialog /deep/ .el-dialog__body {
  max-height: 600px;
  overflow-y: auto;
}

/* 通话记录编辑弹框样式 */
.call-edit-dialog .el-textarea__inner {
  font-size: 14px;
  line-height: 1.8;
  resize: vertical;
}

.call-edit-dialog .word-count-tip {
  text-align: right;
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.call-edit-dialog .word-count-tip .word-limit-warning {
  color: #f56c6c;
  font-weight: 500;
}

/* 编辑图标样式 */
.edit-icon {
  color: #409eff;
  font-size: 16px;
  vertical-align: middle;
}

.edit-icon:hover {
  color: #66b1ff;
}
</style>
